var _style;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotransactions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-consulting:not(.animated) .animable {opacity: 0;}svg#freepik_stories-consulting.animated #freepik--background-complete--inject-166 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideRight;animation-delay: 0s;}svg#freepik_stories-consulting.animated #freepik--Shadow--inject-166 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown;animation-delay: 0s;}svg#freepik_stories-consulting.animated #freepik--Plant--inject-166 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomIn;animation-delay: 0s;}svg#freepik_stories-consulting.animated #freepik--Floor--inject-166 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown;animation-delay: 0s;}svg#freepik_stories-consulting.animated #freepik--character-1--inject-166 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown;animation-delay: 0s;}svg#freepik_stories-consulting.animated #freepik--Desk--inject-166 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideRight;animation-delay: 0s;}svg#freepik_stories-consulting.animated #freepik--Device--inject-166 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp;animation-delay: 0s;}svg#freepik_stories-consulting.animated #freepik--character-2--inject-166 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomIn;animation-delay: 0s;}svg#freepik_stories-consulting.animated #freepik--speech-bubble--inject-166 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) fadeIn;animation-delay: 0s;}            @keyframes slideRight {                0% {                    opacity: 0;                    transform: translateX(30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }                    @keyframes slideDown {                0% {                    opacity: 0;                    transform: translateY(-30px);                }                100% {                    opacity: 1;                    transform: translateY(0);                }            }                    @keyframes zoomIn {                0% {                    opacity: 0;                    transform: scale(0.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }                    @keyframes slideUp {                0% {                    opacity: 0;                    transform: translateY(30px);                }                100% {                    opacity: 1;                    transform: inherit;                }            }                    @keyframes fadeIn {                0% {                    opacity: 0;                }                100% {                    opacity: 1;                }            }")), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "249.885px 188.651px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M82.59,327.06l-13.12.27-6.66.12c-2.23,0-4.47,0-6.7.05h-.44v-.44l-.06-11.19v-.51h.5l13.24.06c4.42,0,8.83.11,13.24.16h.28v.27c0,1.89-.09,3.78-.13,5.65Zm0,0-.14-5.66c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.82.16-13.24.16l-13.24.07.5-.5,0,11.19-.45-.45c2.18,0,4.36,0,6.55.05l6.58.12Z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "69.24px 321.43px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M67.82,341.17l-13.12.27-6.66.12c-2.23,0-4.47,0-6.7.05H40.9v-.44L40.84,330v-.51h.5l13.24.06c4.41,0,8.83.11,13.24.16h.28V330c0,1.89-.08,3.78-.13,5.65Zm0,0-.14-5.66c-.05-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.83.16-13.24.16l-13.24.06.5-.49-.05,11.19-.45-.45c2.18,0,4.36,0,6.55,0l6.58.12Z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "54.47px 335.55px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M338.6,202.49l-13.13.28-6.66.11c-2.22.05-4.46,0-6.69.06h-.44v-.45l-.05-11.19v-.5h.5l13.24.07c4.41,0,8.83.11,13.24.16h.28v.27c0,1.9-.08,3.79-.13,5.66Zm0,0-.14-5.65c0-1.86-.11-3.71-.13-5.54l.27.28c-4.41,0-8.83.15-13.24.16l-13.24.06.5-.5-.06,11.19-.44-.44c2.18,0,4.36,0,6.54,0l6.58.11Z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "325.26px 196.87px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M323.83,216.6l-13.13.28L304,217c-2.22,0-4.46,0-6.69.06h-.45v-.45l0-11.19v-.5h.5l13.24.07c4.41,0,8.82.11,13.24.16h.27v.27c0,1.9-.09,3.79-.13,5.66Zm0,0-.14-5.65c-.05-1.86-.12-3.71-.14-5.54l.28.28c-4.42.05-8.83.15-13.24.16l-13.24.06.5-.5-.06,11.19-.44-.44c2.18,0,4.36,0,6.54.05l6.58.11Z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "310.485px 210.99px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M309.11,202.49l-13.12.28-6.66.11c-2.23.05-4.46,0-6.7.06h-.44v-.45l-.06-11.19v-.5h.5l13.24.07c4.42,0,8.83.11,13.24.16h.28v.27c0,1.9-.09,3.79-.13,5.66Zm0,0-.14-5.65c0-1.86-.11-3.71-.13-5.54l.27.28c-4.41,0-8.82.15-13.24.16l-13.24.06.5-.5-.05,11.19-.45-.44c2.19,0,4.36,0,6.55,0l6.58.11Z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "295.76px 196.87px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M458.66,341.17l-13.13.27-6.66.12c-2.22,0-4.46,0-6.69.05h-.45v-.44L431.68,330v-.51h.5l13.24.06c4.41,0,8.83.11,13.24.16h.27V330c0,1.89-.08,3.78-.13,5.65Zm0,0-.14-5.66c0-1.86-.12-3.7-.13-5.53l.27.27c-4.41.05-8.83.16-13.24.16l-13.24.06.5-.49-.06,11.19-.44-.45c2.18,0,4.36,0,6.54,0l6.58.12Z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "445.305px 335.55px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M443.89,67.49l-13.13.27-6.66.12c-2.22,0-4.46,0-6.69.05H417v-.45l0-11.19v-.51h.51l13.24.06c4.41,0,8.82.11,13.24.16h.27v.27c0,1.9-.09,3.78-.13,5.65Zm0,0-.14-5.66c-.05-1.86-.12-3.7-.14-5.53l.28.27c-4.42,0-8.83.16-13.24.16l-13.24.07.5-.5-.06,11.19-.44-.45c2.18,0,4.35,0,6.54.06l6.58.11Z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "430.63px 61.855px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M458.66,81.6l-13.13.27-6.66.12c-2.22,0-4.46,0-6.69.05h-.45V81.6l-.05-11.19V69.9h.5l13.24.06c4.41,0,8.83.11,13.24.16h.27v.27c0,1.89-.08,3.78-.13,5.65Zm0,0-.14-5.66c0-1.86-.12-3.7-.13-5.53l.27.27c-4.41,0-8.83.16-13.24.16l-13.24.07.5-.5-.06,11.19-.44-.45c2.18,0,4.36,0,6.54.06l6.58.11Z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "445.305px 75.97px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M82.59,67.49l-13.12.27-6.66.12c-2.23,0-4.47,0-6.7.05h-.44v-.45L55.61,56.3v-.51h.5l13.24.06c4.42,0,8.83.11,13.24.16h.28v.27c0,1.9-.09,3.78-.13,5.65Zm0,0-.14-5.66c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41,0-8.82.16-13.24.16l-13.24.07.5-.5,0,11.19L56.11,67c2.18,0,4.36,0,6.55.06l6.58.11Z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "69.24px 61.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m89.17 37.17c-26.9 9.4-13.59 47.66 13.36 38.25s13.58-47.66-13.36-38.25z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "95.8596px 56.2948px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M113.46,54.17c.86,7.08-2.6,14.7-12.07,18C79,80,68,48.22,90.3,40.42l.44-.14C69.86,48,80.47,78,101.79,70.59,110.48,67.55,113.91,60.71,113.46,54.17Z",
    fill: "#dbdbdb",
    style: {
      transformOrigin: "95.8437px 56.8405px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M91.92,44.55a.73.73,0,0,1,.93.4L93.22,46a10.57,10.57,0,0,1,5.83.06c.33.09.53.2.62.47a.77.77,0,0,1-.52.93.8.8,0,0,1-.59,0,9.21,9.21,0,0,0-5-.2l2.6,7.45c4.72-.69,7.12.18,8,2.79,1,2.82-.91,5.72-4.51,7.1l.73,2.08a.74.74,0,0,1-1.4.48l-.74-2.1a12.08,12.08,0,0,1-7.45-.3.68.68,0,0,1-.51-.44.77.77,0,0,1,.49-.92.83.83,0,0,1,.59,0,10.35,10.35,0,0,0,6.52.44l-2.65-7.59c-4.67.65-7-.19-7.92-2.85s.91-5.63,4.43-6.95l-.35-1A.72.72,0,0,1,91.92,44.55Zm2.9,10.34-2.54-7.27c-2.81,1-4.13,3.24-3.46,5.16S90.78,55.38,94.82,54.89Zm1.85,1.18,2.56,7.35c2.89-1.07,4.25-3.27,3.54-5.3C102.13,56.29,100.72,55.52,96.67,56.07Z",
    fill: "#dbdbdb",
    style: {
      transformOrigin: "95.7491px 56.0803px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m416.4 187.76c-21.88 16.66 2.76 49.1 24.68 32.41s-2.76-49.1-24.68-32.41z",
    fill: "#dbdbdb",
    style: {
      transformOrigin: "428.749px 203.964px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m418.46 186.19c-20.86 15.88 3.78 48.32 24.67 32.41s-3.78-48.31-24.67-32.41z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "430.801px 202.396px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M445.79,195.78c3.13,6.43,2.58,14.48-4.76,20.07-17.33,13.2-37.79-13.72-20.48-26.9.11-.09.23-.17.35-.25-16,12.72,3.43,38.14,20,25.56A14.9,14.9,0,0,0,445.79,195.78Z",
    fill: "#dbdbdb",
    style: {
      transformOrigin: "430.79px 204.049px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M426.57,190.75a.69.69,0,0,1,.88.4l.39,1.06a9.28,9.28,0,0,1,5.43.1.82.82,0,0,1,.6.47.73.73,0,0,1-.45.92.69.69,0,0,1-.55,0,8.06,8.06,0,0,0-4.63-.25l2.77,7.44c4.36-.65,6.62.23,7.59,2.84,1,2.82-.57,5.69-3.86,7l.77,2.07a.69.69,0,0,1-.4.88.68.68,0,0,1-.87-.4l-.78-2.1a10.74,10.74,0,0,1-6.94-.35.73.73,0,0,1-.5-.45.75.75,0,0,1,.41-.92.77.77,0,0,1,.55,0,9.17,9.17,0,0,0,6.09.49l-2.82-7.57c-4.32.6-6.51-.24-7.5-2.9s.58-5.6,3.8-6.89l-.38-1A.69.69,0,0,1,426.57,190.75Zm3.17,10.31-2.69-7.25c-2.56,1-3.69,3.18-3,5.1S426,201.51,429.74,201.06Zm1.78,1.19,2.72,7.34c2.64-1.05,3.8-3.23,3.05-5.25C436.6,202.51,435.26,201.74,431.52,202.25Z",
    fill: "#dbdbdb",
    style: {
      transformOrigin: "430.677px 202.215px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M73.44,243.65c25.62,4.59,18.85,42.54-6.81,37.94S47.78,239,73.44,243.65Z",
    fill: "#dbdbdb",
    style: {
      transformOrigin: "70.0267px 262.616px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m71 243.21c24.41 4.38 17.64 42.34-6.81 38s-17.61-42.38 6.81-38z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "67.5914px 262.207px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M52.15,263.08c.13,6.76,4.06,13.31,12.66,14.85,20.29,3.65,25.91-27.85,5.65-31.49l-.4-.06c19,3.8,13.56,33.61-5.79,30.14A14.09,14.09,0,0,1,52.15,263.08Z",
    fill: "#dbdbdb",
    style: {
      transformOrigin: "67.6406px 262.302px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M69.07,249.21a.65.65,0,0,1,.51.75l-.2,1a8.77,8.77,0,0,1,4.36,2.72.76.76,0,0,1,.25.68.71.71,0,0,1-1.25.26,7.59,7.59,0,0,0-3.63-2.45l-1.38,7.38c3.85,1.59,5.26,3.41,4.78,6-.52,2.79-3.24,4.34-6.56,3.83l-.38,2.06a.65.65,0,0,1-.75.51.66.66,0,0,1-.52-.75l.39-2.09a10.09,10.09,0,0,1-5.46-3.66.68.68,0,0,1,.6-1.14.64.64,0,0,1,.44.27A8.68,8.68,0,0,0,65,268l1.4-7.52c-3.8-1.61-5.16-3.37-4.67-6s3.19-4.27,6.43-3.75l.18-1A.66.66,0,0,1,69.07,249.21Zm-2.45,9.91,1.34-7.2c-2.57-.42-4.54.79-4.9,2.69S63.37,257.67,66.62,259.12Zm.86,1.83-1.36,7.28c2.65.44,4.65-.77,5-2.78C71.48,263.63,70.77,262.35,67.48,261Z",
    fill: "#dbdbdb",
    style: {
      transformOrigin: "66.5204px 260.582px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m429.12 124.93v23.52l-15.27 17.89a23.52 23.52 0 0 1 15.27-41.41z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "417.359px 145.635px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m457.43 150.85a23.52 23.52 0 0 1-38.79 17.89l15.27-17.89v-23.53a23.49 23.49 0 0 1 23.52 23.53z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "438.035px 150.845px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m457.43 150.85a23.52 23.52 0 0 1-38.79 17.89l15.27-17.89v-23.53a23.49 23.49 0 0 1 23.52 23.53z",
    fill: "#dbdbdb",
    style: {
      transformOrigin: "438.035px 150.845px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 418.14,
    y: 106.64,
    width: 1,
    height: 30.35,
    fill: "#c7c7c7",
    style: {
      transformOrigin: "418.64px 121.815px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m418.64 107.14a2.63 2.63 0 1 1 2.63-2.63 2.63 2.63 0 0 1-2.63 2.63zm0-4.25a1.63 1.63 0 1 0 1.63 1.62 1.63 1.63 0 0 0-1.63-1.62z",
    fill: "#c7c7c7",
    style: {
      transformOrigin: "418.64px 104.51px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 425.09,
    y: 102.39,
    width: 23.57,
    height: 1.06,
    fill: "#c7c7c7",
    style: {
      transformOrigin: "436.875px 102.92px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 425.09,
    y: 104.51,
    width: 13.34,
    height: 1.06,
    fill: "#c7c7c7",
    style: {
      transformOrigin: "431.76px 105.04px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m91.59 204.76a23.21 23.21 0 1 1-23-26.61v23.21z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "68.5052px 201.36px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M96.57,196.63a22.39,22.39,0,0,1-.26,3.4l-23-3.4v-23.2a23.19,23.19,0,0,1,23.21,23.2Z",
    fill: "#dbdbdb",
    style: {
      transformOrigin: "84.94px 186.73px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 80.41,
    y: 213.71,
    width: 24.68,
    height: 1,
    fill: "#c7c7c7",
    style: {
      transformOrigin: "92.75px 214.21px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m106.81 216.44a2.23 2.23 0 1 1 2.23-2.23 2.23 2.23 0 0 1-2.23 2.23zm0-3.46a1.23 1.23 0 1 0 1.23 1.23 1.24 1.24 0 0 0-1.23-1.21z",
    fill: "#c7c7c7",
    style: {
      transformOrigin: "106.81px 214.21px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 113.09,
    y: 212.91,
    width: 19.17,
    height: 0.86,
    fill: "#c7c7c7",
    style: {
      transformOrigin: "122.675px 213.34px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 113.09,
    y: 214.64,
    width: 10.85,
    height: 0.86,
    fill: "#c7c7c7",
    style: {
      transformOrigin: "118.515px 215.07px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 92.88,
    y: 66.25,
    width: 314.24,
    height: 98.29,
    fill: "#fff",
    style: {
      transformOrigin: "250px 115.395px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 224.95,
    y: 64.62,
    width: 183.8,
    height: 101.56,
    fill: "#fff",
    style: {
      transformOrigin: "316.85px 115.4px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "408.75 89.91 408.75 166.18 224.95 166.18 224.95 98.64 240.89 98.64 240.89 118.01 245 118.01 245 107.05 265.27 107.05 265.27 124.41 267.96 124.41 267.96 83.67 285.58 83.67 285.58 94.85 294.62 94.85 294.62 108.76 297.35 108.76 297.35 100.01 313.37 100.01 313.37 126.12 318.06 126.12 318.06 104.9 332.71 104.9 332.71 88.77 342.67 88.77 342.67 79.59 354.19 79.59 354.19 120.32 358.07 120.32 358.07 103.32 377.06 103.32 377.06 127.65 379.68 127.65 379.68 107.79 398.93 107.79 398.93 89.91",
    fill: "#ebebeb",
    style: {
      transformOrigin: "316.85px 122.885px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 226.9,
    y: 101.08,
    width: 2.7,
    height: 3.7,
    fill: "#fff",
    style: {
      transformOrigin: "228.25px 102.93px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 231.58,
    y: 101.08,
    width: 2.7,
    height: 3.7,
    fill: "#fff",
    style: {
      transformOrigin: "232.93px 102.93px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 236.25,
    y: 101.08,
    width: 2.7,
    height: 3.7,
    fill: "#fff",
    style: {
      transformOrigin: "237.6px 102.93px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 226.9,
    y: 106.65,
    width: 2.7,
    height: 3.7,
    fill: "#fff",
    style: {
      transformOrigin: "228.25px 108.5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 231.58,
    y: 106.65,
    width: 2.7,
    height: 3.7,
    fill: "#fff",
    style: {
      transformOrigin: "232.93px 108.5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 236.25,
    y: 106.65,
    width: 2.7,
    height: 3.7,
    fill: "#fff",
    style: {
      transformOrigin: "237.6px 108.5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 226.9,
    y: 112.22,
    width: 2.7,
    height: 3.7,
    fill: "#fff",
    style: {
      transformOrigin: "228.25px 114.07px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 231.58,
    y: 112.22,
    width: 2.7,
    height: 3.7,
    fill: "#fff",
    style: {
      transformOrigin: "232.93px 114.07px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 236.25,
    y: 112.22,
    width: 2.7,
    height: 3.7,
    fill: "#fff",
    style: {
      transformOrigin: "237.6px 114.07px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 226.9,
    y: 117.79,
    width: 2.7,
    height: 3.7,
    fill: "#fff",
    style: {
      transformOrigin: "228.25px 119.64px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 231.58,
    y: 117.79,
    width: 2.7,
    height: 3.7,
    fill: "#fff",
    style: {
      transformOrigin: "232.93px 119.64px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 236.25,
    y: 117.79,
    width: 2.7,
    height: 3.7,
    fill: "#fff",
    style: {
      transformOrigin: "237.6px 119.64px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 320.31,
    y: 107.54,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "321.66px 109.085px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 324.98,
    y: 107.54,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "326.33px 109.085px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 329.66,
    y: 107.54,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "331.01px 109.085px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 320.31,
    y: 112.19,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "321.66px 113.735px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 324.98,
    y: 112.19,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "326.33px 113.735px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 329.66,
    y: 112.19,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "331.01px 113.735px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 320.31,
    y: 116.84,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "321.66px 118.385px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 324.98,
    y: 116.84,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "326.33px 118.385px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 329.66,
    y: 116.84,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "331.01px 118.385px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 320.31,
    y: 121.48,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "321.66px 123.025px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 324.98,
    y: 121.48,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "326.33px 123.025px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 329.66,
    y: 121.48,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "331.01px 123.025px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 320.31,
    y: 126.25,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "321.66px 127.795px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 324.98,
    y: 126.25,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "326.33px 127.795px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 329.66,
    y: 126.25,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "331.01px 127.795px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 320.31,
    y: 131.01,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "321.66px 132.555px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 324.98,
    y: 131.01,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "326.33px 132.555px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 329.66,
    y: 131.01,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "331.01px 132.555px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 320.31,
    y: 135.77,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "321.66px 137.315px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 324.98,
    y: 135.77,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "326.33px 137.315px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 329.66,
    y: 135.77,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "331.01px 137.315px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 320.31,
    y: 140.53,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "321.66px 142.075px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 324.98,
    y: 140.53,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "326.33px 142.075px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 329.66,
    y: 140.53,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "331.01px 142.075px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 247.3,
    y: 109.42,
    width: 15.53,
    height: 2.32,
    fill: "#fff",
    style: {
      transformOrigin: "255.065px 110.58px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 247.3,
    y: 113.91,
    width: 15.53,
    height: 2.32,
    fill: "#fff",
    style: {
      transformOrigin: "255.065px 115.07px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 247.3,
    y: 118.41,
    width: 15.53,
    height: 2.32,
    fill: "#fff",
    style: {
      transformOrigin: "255.065px 119.57px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 247.3,
    y: 122.9,
    width: 15.53,
    height: 2.32,
    fill: "#fff",
    style: {
      transformOrigin: "255.065px 124.06px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 247.3,
    y: 127.39,
    width: 15.53,
    height: 2.32,
    fill: "#fff",
    style: {
      transformOrigin: "255.065px 128.55px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 247.3,
    y: 131.88,
    width: 15.53,
    height: 2.32,
    fill: "#fff",
    style: {
      transformOrigin: "255.065px 133.04px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 247.3,
    y: 136.38,
    width: 15.53,
    height: 2.32,
    fill: "#fff",
    style: {
      transformOrigin: "255.065px 137.54px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 247.3,
    y: 140.87,
    width: 15.53,
    height: 2.32,
    fill: "#fff",
    style: {
      transformOrigin: "255.065px 142.03px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 360.37,
    y: 105.48,
    width: 14.28,
    height: 2.32,
    fill: "#fff",
    style: {
      transformOrigin: "367.51px 106.64px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 360.37,
    y: 109.97,
    width: 14.28,
    height: 2.32,
    fill: "#fff",
    style: {
      transformOrigin: "367.51px 111.13px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 360.37,
    y: 114.47,
    width: 14.28,
    height: 2.32,
    fill: "#fff",
    style: {
      transformOrigin: "367.51px 115.63px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 360.37,
    y: 118.96,
    width: 14.28,
    height: 2.32,
    fill: "#fff",
    style: {
      transformOrigin: "367.51px 120.12px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 360.37,
    y: 123.45,
    width: 14.28,
    height: 2.32,
    fill: "#fff",
    style: {
      transformOrigin: "367.51px 124.61px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 360.37,
    y: 127.94,
    width: 14.28,
    height: 2.32,
    fill: "#fff",
    style: {
      transformOrigin: "367.51px 129.1px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 360.37,
    y: 132.44,
    width: 14.28,
    height: 2.32,
    fill: "#fff",
    style: {
      transformOrigin: "367.51px 133.6px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 360.37,
    y: 136.93,
    width: 14.28,
    height: 2.32,
    fill: "#fff",
    style: {
      transformOrigin: "367.51px 138.09px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 360.37,
    y: 141.2,
    width: 14.28,
    height: 2.32,
    fill: "#fff",
    style: {
      transformOrigin: "367.51px 142.36px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 360.37,
    y: 145.47,
    width: 14.28,
    height: 2.32,
    fill: "#fff",
    style: {
      transformOrigin: "367.51px 146.63px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 360.37,
    y: 149.74,
    width: 14.28,
    height: 2.32,
    fill: "#fff",
    style: {
      transformOrigin: "367.51px 150.9px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 360.37,
    y: 154.01,
    width: 14.28,
    height: 2.32,
    fill: "#fff",
    style: {
      transformOrigin: "367.51px 155.17px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 360.37,
    y: 158.27,
    width: 14.28,
    height: 2.32,
    fill: "#fff",
    style: {
      transformOrigin: "367.51px 159.43px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 382.65,
    y: 110.91,
    width: 15.08,
    height: 2.32,
    fill: "#fff",
    style: {
      transformOrigin: "390.19px 112.07px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 382.65,
    y: 115.4,
    width: 15.08,
    height: 2.32,
    fill: "#fff",
    style: {
      transformOrigin: "390.19px 116.56px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 382.65,
    y: 119.89,
    width: 15.08,
    height: 2.32,
    fill: "#fff",
    style: {
      transformOrigin: "390.19px 121.05px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 382.65,
    y: 124.39,
    width: 15.08,
    height: 2.32,
    fill: "#fff",
    style: {
      transformOrigin: "390.19px 125.55px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 382.65,
    y: 128.88,
    width: 15.08,
    height: 2.32,
    fill: "#fff",
    style: {
      transformOrigin: "390.19px 130.04px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 382.65,
    y: 133.37,
    width: 15.08,
    height: 2.32,
    fill: "#fff",
    style: {
      transformOrigin: "390.19px 134.53px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 382.65,
    y: 137.86,
    width: 15.08,
    height: 2.32,
    fill: "#fff",
    style: {
      transformOrigin: "390.19px 139.02px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 382.65,
    y: 142.36,
    width: 15.08,
    height: 2.32,
    fill: "#fff",
    style: {
      transformOrigin: "390.19px 143.52px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 382.65,
    y: 146.38,
    width: 15.08,
    height: 2.32,
    fill: "#fff",
    style: {
      transformOrigin: "390.19px 147.54px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 382.65,
    y: 150.4,
    width: 15.08,
    height: 2.32,
    fill: "#fff",
    style: {
      transformOrigin: "390.19px 151.56px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 382.65,
    y: 154.42,
    width: 15.08,
    height: 2.32,
    fill: "#fff",
    style: {
      transformOrigin: "390.19px 155.58px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 302.04,
    y: 102.11,
    width: 4.8,
    height: 2.24,
    fill: "#fff",
    style: {
      transformOrigin: "304.44px 103.23px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 302.04,
    y: 106.45,
    width: 4.8,
    height: 2.24,
    fill: "#fff",
    style: {
      transformOrigin: "304.44px 107.57px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 302.04,
    y: 110.79,
    width: 4.8,
    height: 2.24,
    fill: "#fff",
    style: {
      transformOrigin: "304.44px 111.91px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 302.04,
    y: 115.12,
    width: 4.8,
    height: 2.24,
    fill: "#fff",
    style: {
      transformOrigin: "304.44px 116.24px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 302.04,
    y: 119.46,
    width: 4.8,
    height: 2.24,
    fill: "#fff",
    style: {
      transformOrigin: "304.44px 120.58px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 302.04,
    y: 123.8,
    width: 4.8,
    height: 2.24,
    fill: "#fff",
    style: {
      transformOrigin: "304.44px 124.92px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 302.04,
    y: 128.14,
    width: 4.8,
    height: 2.24,
    fill: "#fff",
    style: {
      transformOrigin: "304.44px 129.26px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 302.04,
    y: 132.48,
    width: 4.8,
    height: 2.24,
    fill: "#fff",
    style: {
      transformOrigin: "304.44px 133.6px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 308.56,
    y: 102.11,
    width: 4.8,
    height: 2.24,
    fill: "#fff",
    style: {
      transformOrigin: "310.96px 103.23px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 308.56,
    y: 106.45,
    width: 4.8,
    height: 2.24,
    fill: "#fff",
    style: {
      transformOrigin: "310.96px 107.57px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 308.56,
    y: 110.79,
    width: 4.8,
    height: 2.24,
    fill: "#fff",
    style: {
      transformOrigin: "310.96px 111.91px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 308.56,
    y: 115.12,
    width: 4.8,
    height: 2.24,
    fill: "#fff",
    style: {
      transformOrigin: "310.96px 116.24px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 308.56,
    y: 119.46,
    width: 4.8,
    height: 2.24,
    fill: "#fff",
    style: {
      transformOrigin: "310.96px 120.58px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 308.56,
    y: 123.8,
    width: 4.8,
    height: 2.24,
    fill: "#fff",
    style: {
      transformOrigin: "310.96px 124.92px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 308.56,
    y: 128.14,
    width: 4.8,
    height: 2.24,
    fill: "#fff",
    style: {
      transformOrigin: "310.96px 129.26px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 308.56,
    y: 132.48,
    width: 4.8,
    height: 2.24,
    fill: "#fff",
    style: {
      transformOrigin: "310.96px 133.6px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 270.63,
    y: 86.01,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "273.13px 87.775px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 278.08,
    y: 86.01,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "280.58px 87.775px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 270.63,
    y: 91.19,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "273.13px 92.955px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 278.08,
    y: 91.19,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "280.58px 92.955px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 270.63,
    y: 96.37,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "273.13px 98.135px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 278.08,
    y: 96.37,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "280.58px 98.135px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 270.63,
    y: 101.55,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "273.13px 103.315px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 278.08,
    y: 101.55,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "280.58px 103.315px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 270.63,
    y: 106.73,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "273.13px 108.495px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 278.08,
    y: 106.73,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "280.58px 108.495px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 270.63,
    y: 111.91,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "273.13px 113.675px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 278.08,
    y: 111.91,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "280.58px 113.675px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 270.63,
    y: 117.09,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "273.13px 118.855px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 278.08,
    y: 117.09,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "280.58px 118.855px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 270.63,
    y: 122.27,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "273.13px 124.035px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 278.08,
    y: 122.27,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "280.58px 124.035px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 287.31,
    y: 96.37,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "289.81px 98.135px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 287.31,
    y: 101.55,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "289.81px 103.315px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 287.31,
    y: 106.73,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "289.81px 108.495px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 287.31,
    y: 111.91,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "289.81px 113.675px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 287.31,
    y: 117.09,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "289.81px 118.855px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 287.31,
    y: 122.27,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "289.81px 124.035px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 270.63,
    y: 127.39,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "273.13px 129.155px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 278.08,
    y: 127.39,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "280.58px 129.155px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 287.31,
    y: 127.39,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "289.81px 129.155px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 270.63,
    y: 132.51,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "273.13px 134.275px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 278.08,
    y: 132.51,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "280.58px 134.275px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 287.31,
    y: 132.51,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "289.81px 134.275px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 270.63,
    y: 137.63,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "273.13px 139.395px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 278.08,
    y: 137.63,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "280.58px 139.395px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 287.31,
    y: 137.63,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "289.81px 139.395px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 270.63,
    y: 142.75,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "273.13px 144.515px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 278.08,
    y: 142.75,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "280.58px 144.515px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 287.31,
    y: 142.75,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "289.81px 144.515px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 270.63,
    y: 147.86,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "273.13px 149.625px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 278.08,
    y: 147.86,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "280.58px 149.625px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 287.31,
    y: 147.86,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "289.81px 149.625px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 334.74,
    y: 91.04,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "336.09px 92.585px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 339.42,
    y: 91.04,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "340.77px 92.585px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 334.74,
    y: 95.69,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "336.09px 97.235px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 339.42,
    y: 95.69,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "340.77px 97.235px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 334.74,
    y: 100.34,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "336.09px 101.885px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 339.42,
    y: 100.34,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "340.77px 101.885px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 334.74,
    y: 104.99,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "336.09px 106.535px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 339.42,
    y: 104.99,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "340.77px 106.535px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 334.74,
    y: 109.75,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "336.09px 111.295px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 339.42,
    y: 109.75,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "340.77px 111.295px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 334.74,
    y: 114.51,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "336.09px 116.055px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 339.42,
    y: 114.51,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "340.77px 116.055px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 334.74,
    y: 119.27,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "336.09px 120.815px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 339.42,
    y: 119.27,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "340.77px 120.815px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 334.74,
    y: 124.04,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "336.09px 125.585px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 339.42,
    y: 124.04,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "340.77px 125.585px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 334.74,
    y: 128.85,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "336.09px 130.395px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 339.42,
    y: 128.85,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "340.77px 130.395px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 334.74,
    y: 133.66,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "336.09px 135.205px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 339.42,
    y: 133.66,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "340.77px 135.205px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 334.74,
    y: 138.48,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "336.09px 140.025px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 339.42,
    y: 138.48,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "340.77px 140.025px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 334.74,
    y: 143.29,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "336.09px 144.835px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 339.42,
    y: 143.29,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "340.77px 144.835px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 400.62,
    y: 91.55,
    width: 2.7,
    height: 3.64,
    fill: "#fff",
    style: {
      transformOrigin: "401.97px 93.37px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 405.3,
    y: 91.55,
    width: 2.7,
    height: 3.64,
    fill: "#fff",
    style: {
      transformOrigin: "406.65px 93.37px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 400.62,
    y: 97.02,
    width: 2.7,
    height: 3.64,
    fill: "#fff",
    style: {
      transformOrigin: "401.97px 98.84px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 405.3,
    y: 97.02,
    width: 2.7,
    height: 3.64,
    fill: "#fff",
    style: {
      transformOrigin: "406.65px 98.84px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 400.62,
    y: 102.5,
    width: 2.7,
    height: 3.64,
    fill: "#fff",
    style: {
      transformOrigin: "401.97px 104.32px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 405.3,
    y: 102.5,
    width: 2.7,
    height: 3.64,
    fill: "#fff",
    style: {
      transformOrigin: "406.65px 104.32px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 400.62,
    y: 107.97,
    width: 2.7,
    height: 3.64,
    fill: "#fff",
    style: {
      transformOrigin: "401.97px 109.79px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 405.3,
    y: 107.97,
    width: 2.7,
    height: 3.64,
    fill: "#fff",
    style: {
      transformOrigin: "406.65px 109.79px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 400.62,
    y: 113.58,
    width: 2.7,
    height: 3.64,
    fill: "#fff",
    style: {
      transformOrigin: "401.97px 115.4px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 405.3,
    y: 113.58,
    width: 2.7,
    height: 3.64,
    fill: "#fff",
    style: {
      transformOrigin: "406.65px 115.4px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 400.62,
    y: 119.19,
    width: 2.7,
    height: 3.64,
    fill: "#fff",
    style: {
      transformOrigin: "401.97px 121.01px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 405.3,
    y: 119.19,
    width: 2.7,
    height: 3.64,
    fill: "#fff",
    style: {
      transformOrigin: "406.65px 121.01px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 400.62,
    y: 124.8,
    width: 2.7,
    height: 3.64,
    fill: "#fff",
    style: {
      transformOrigin: "401.97px 126.62px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 405.3,
    y: 124.8,
    width: 2.7,
    height: 3.64,
    fill: "#fff",
    style: {
      transformOrigin: "406.65px 126.62px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 400.62,
    y: 130.42,
    width: 2.7,
    height: 3.64,
    fill: "#fff",
    style: {
      transformOrigin: "401.97px 132.24px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 405.3,
    y: 130.42,
    width: 2.7,
    height: 3.64,
    fill: "#fff",
    style: {
      transformOrigin: "406.65px 132.24px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 400.62,
    y: 136.09,
    width: 2.7,
    height: 3.64,
    fill: "#fff",
    style: {
      transformOrigin: "401.97px 137.91px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 405.3,
    y: 136.09,
    width: 2.7,
    height: 3.64,
    fill: "#fff",
    style: {
      transformOrigin: "406.65px 137.91px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 400.62,
    y: 141.76,
    width: 2.7,
    height: 3.64,
    fill: "#fff",
    style: {
      transformOrigin: "401.97px 143.58px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 405.3,
    y: 141.76,
    width: 2.7,
    height: 3.64,
    fill: "#fff",
    style: {
      transformOrigin: "406.65px 143.58px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 400.62,
    y: 147.43,
    width: 2.7,
    height: 3.64,
    fill: "#fff",
    style: {
      transformOrigin: "401.97px 149.25px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 405.3,
    y: 147.43,
    width: 2.7,
    height: 3.64,
    fill: "#fff",
    style: {
      transformOrigin: "406.65px 149.25px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 400.62,
    y: 153.1,
    width: 2.7,
    height: 3.64,
    fill: "#fff",
    style: {
      transformOrigin: "401.97px 154.92px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 405.3,
    y: 153.1,
    width: 2.7,
    height: 3.64,
    fill: "#fff",
    style: {
      transformOrigin: "406.65px 154.92px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 344.74,
    y: 91.04,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "346.09px 92.585px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 349.42,
    y: 91.04,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "350.77px 92.585px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 344.74,
    y: 86.28,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "346.09px 87.825px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 349.42,
    y: 86.28,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "350.77px 87.825px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 344.74,
    y: 81.51,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "346.09px 83.055px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 349.42,
    y: 81.51,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "350.77px 83.055px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 344.74,
    y: 95.69,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "346.09px 97.235px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 349.42,
    y: 95.69,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "350.77px 97.235px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 344.74,
    y: 100.34,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "346.09px 101.885px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 349.42,
    y: 100.34,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "350.77px 101.885px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 344.74,
    y: 104.99,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "346.09px 106.535px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 349.42,
    y: 104.99,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "350.77px 106.535px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 344.74,
    y: 109.75,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "346.09px 111.295px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 349.42,
    y: 109.75,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "350.77px 111.295px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 344.74,
    y: 114.51,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "346.09px 116.055px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 349.42,
    y: 114.51,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "350.77px 116.055px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 344.74,
    y: 119.27,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "346.09px 120.815px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 349.42,
    y: 119.27,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "350.77px 120.815px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 344.74,
    y: 124.04,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "346.09px 125.585px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 349.42,
    y: 124.04,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "350.77px 125.585px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 344.74,
    y: 128.85,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "346.09px 130.395px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 349.42,
    y: 128.85,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "350.77px 130.395px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 344.74,
    y: 133.66,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "346.09px 135.205px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 349.42,
    y: 133.66,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "350.77px 135.205px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 344.74,
    y: 138.48,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "346.09px 140.025px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 349.42,
    y: 138.48,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "350.77px 140.025px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 344.74,
    y: 143.29,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "346.09px 144.835px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 349.42,
    y: 143.29,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "350.77px 144.835px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "224.95 166.18 91.82 166.18 91.82 98.64 107.76 98.64 107.76 118.01 111.87 118.01 111.87 107.05 132.14 107.05 132.14 124.41 134.83 124.41 134.83 83.67 152.45 83.67 152.45 94.85 161.49 94.85 161.49 108.76 164.22 108.76 164.22 100.01 180.24 100.01 180.24 126.12 184.93 126.12 184.93 104.9 199.58 104.9 199.58 88.77 209.54 88.77 221.06 88.83 221.06 120.32 224.94 120.32",
    fill: "#ebebeb",
    style: {
      transformOrigin: "158.385px 124.925px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 93.77,
    y: 101.08,
    width: 2.7,
    height: 3.7,
    fill: "#fff",
    style: {
      transformOrigin: "95.12px 102.93px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 98.45,
    y: 101.08,
    width: 2.7,
    height: 3.7,
    fill: "#fff",
    style: {
      transformOrigin: "99.8px 102.93px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 103.13,
    y: 101.08,
    width: 2.7,
    height: 3.7,
    fill: "#fff",
    style: {
      transformOrigin: "104.48px 102.93px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 93.77,
    y: 106.65,
    width: 2.7,
    height: 3.7,
    fill: "#fff",
    style: {
      transformOrigin: "95.12px 108.5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 98.45,
    y: 106.65,
    width: 2.7,
    height: 3.7,
    fill: "#fff",
    style: {
      transformOrigin: "99.8px 108.5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 103.13,
    y: 106.65,
    width: 2.7,
    height: 3.7,
    fill: "#fff",
    style: {
      transformOrigin: "104.48px 108.5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 93.77,
    y: 112.22,
    width: 2.7,
    height: 3.7,
    fill: "#fff",
    style: {
      transformOrigin: "95.12px 114.07px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 98.45,
    y: 112.22,
    width: 2.7,
    height: 3.7,
    fill: "#fff",
    style: {
      transformOrigin: "99.8px 114.07px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 103.13,
    y: 112.22,
    width: 2.7,
    height: 3.7,
    fill: "#fff",
    style: {
      transformOrigin: "104.48px 114.07px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 93.77,
    y: 117.79,
    width: 2.7,
    height: 3.7,
    fill: "#fff",
    style: {
      transformOrigin: "95.12px 119.64px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 98.45,
    y: 117.79,
    width: 2.7,
    height: 3.7,
    fill: "#fff",
    style: {
      transformOrigin: "99.8px 119.64px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 103.13,
    y: 117.79,
    width: 2.7,
    height: 3.7,
    fill: "#fff",
    style: {
      transformOrigin: "104.48px 119.64px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 187.18,
    y: 107.54,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "188.53px 109.085px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 191.85,
    y: 107.54,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "193.2px 109.085px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 196.53,
    y: 107.54,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "197.88px 109.085px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 187.18,
    y: 112.19,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "188.53px 113.735px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 191.85,
    y: 112.19,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "193.2px 113.735px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 196.53,
    y: 112.19,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "197.88px 113.735px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 187.18,
    y: 116.84,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "188.53px 118.385px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 191.85,
    y: 116.84,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "193.2px 118.385px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 196.53,
    y: 116.84,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "197.88px 118.385px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 187.18,
    y: 121.48,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "188.53px 123.025px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 191.85,
    y: 121.48,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "193.2px 123.025px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 196.53,
    y: 121.48,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "197.88px 123.025px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 187.18,
    y: 126.25,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "188.53px 127.795px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 191.85,
    y: 126.25,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "193.2px 127.795px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 196.53,
    y: 126.25,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "197.88px 127.795px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 187.18,
    y: 131.01,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "188.53px 132.555px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 191.85,
    y: 131.01,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "193.2px 132.555px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 196.53,
    y: 131.01,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "197.88px 132.555px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 187.18,
    y: 135.77,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "188.53px 137.315px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 191.85,
    y: 135.77,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "193.2px 137.315px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 196.53,
    y: 135.77,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "197.88px 137.315px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 187.18,
    y: 140.53,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "188.53px 142.075px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 191.85,
    y: 140.53,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "193.2px 142.075px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 196.53,
    y: 140.53,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "197.88px 142.075px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 114.17,
    y: 109.42,
    width: 15.53,
    height: 2.32,
    fill: "#fff",
    style: {
      transformOrigin: "121.935px 110.58px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 114.17,
    y: 113.91,
    width: 15.53,
    height: 2.32,
    fill: "#fff",
    style: {
      transformOrigin: "121.935px 115.07px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 114.17,
    y: 118.41,
    width: 15.53,
    height: 2.32,
    fill: "#fff",
    style: {
      transformOrigin: "121.935px 119.57px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 114.17,
    y: 122.9,
    width: 15.53,
    height: 2.32,
    fill: "#fff",
    style: {
      transformOrigin: "121.935px 124.06px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 114.17,
    y: 127.39,
    width: 15.53,
    height: 2.32,
    fill: "#fff",
    style: {
      transformOrigin: "121.935px 128.55px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 114.17,
    y: 131.88,
    width: 15.53,
    height: 2.32,
    fill: "#fff",
    style: {
      transformOrigin: "121.935px 133.04px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 114.17,
    y: 136.38,
    width: 15.53,
    height: 2.32,
    fill: "#fff",
    style: {
      transformOrigin: "121.935px 137.54px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 114.17,
    y: 140.87,
    width: 15.53,
    height: 2.32,
    fill: "#fff",
    style: {
      transformOrigin: "121.935px 142.03px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 168.91,
    y: 102.11,
    width: 4.8,
    height: 2.24,
    fill: "#fff",
    style: {
      transformOrigin: "171.31px 103.23px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 168.91,
    y: 106.45,
    width: 4.8,
    height: 2.24,
    fill: "#fff",
    style: {
      transformOrigin: "171.31px 107.57px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 168.91,
    y: 110.79,
    width: 4.8,
    height: 2.24,
    fill: "#fff",
    style: {
      transformOrigin: "171.31px 111.91px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 168.91,
    y: 115.12,
    width: 4.8,
    height: 2.24,
    fill: "#fff",
    style: {
      transformOrigin: "171.31px 116.24px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 168.91,
    y: 119.46,
    width: 4.8,
    height: 2.24,
    fill: "#fff",
    style: {
      transformOrigin: "171.31px 120.58px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 168.91,
    y: 123.8,
    width: 4.8,
    height: 2.24,
    fill: "#fff",
    style: {
      transformOrigin: "171.31px 124.92px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 168.91,
    y: 128.14,
    width: 4.8,
    height: 2.24,
    fill: "#fff",
    style: {
      transformOrigin: "171.31px 129.26px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 168.91,
    y: 132.48,
    width: 4.8,
    height: 2.24,
    fill: "#fff",
    style: {
      transformOrigin: "171.31px 133.6px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 175.43,
    y: 102.11,
    width: 4.8,
    height: 2.24,
    fill: "#fff",
    style: {
      transformOrigin: "177.83px 103.23px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 175.43,
    y: 106.45,
    width: 4.8,
    height: 2.24,
    fill: "#fff",
    style: {
      transformOrigin: "177.83px 107.57px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 175.43,
    y: 110.79,
    width: 4.8,
    height: 2.24,
    fill: "#fff",
    style: {
      transformOrigin: "177.83px 111.91px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 175.43,
    y: 115.12,
    width: 4.8,
    height: 2.24,
    fill: "#fff",
    style: {
      transformOrigin: "177.83px 116.24px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 175.43,
    y: 119.46,
    width: 4.8,
    height: 2.24,
    fill: "#fff",
    style: {
      transformOrigin: "177.83px 120.58px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 175.43,
    y: 123.8,
    width: 4.8,
    height: 2.24,
    fill: "#fff",
    style: {
      transformOrigin: "177.83px 124.92px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 175.43,
    y: 128.14,
    width: 4.8,
    height: 2.24,
    fill: "#fff",
    style: {
      transformOrigin: "177.83px 129.26px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 175.43,
    y: 132.48,
    width: 4.8,
    height: 2.24,
    fill: "#fff",
    style: {
      transformOrigin: "177.83px 133.6px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 137.5,
    y: 86.01,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "140px 87.775px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 144.95,
    y: 86.01,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "147.45px 87.775px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 137.5,
    y: 91.19,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "140px 92.955px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 144.95,
    y: 91.19,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "147.45px 92.955px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 137.5,
    y: 96.37,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "140px 98.135px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 144.95,
    y: 96.37,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "147.45px 98.135px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 137.5,
    y: 101.55,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "140px 103.315px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 144.95,
    y: 101.55,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "147.45px 103.315px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 137.5,
    y: 106.73,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "140px 108.495px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 144.95,
    y: 106.73,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "147.45px 108.495px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 137.5,
    y: 111.91,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "140px 113.675px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 144.95,
    y: 111.91,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "147.45px 113.675px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 137.5,
    y: 117.09,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "140px 118.855px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 144.95,
    y: 117.09,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "147.45px 118.855px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 137.5,
    y: 122.27,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "140px 124.035px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 144.95,
    y: 122.27,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "147.45px 124.035px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 154.18,
    y: 96.37,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "156.68px 98.135px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 154.18,
    y: 101.55,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "156.68px 103.315px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 154.18,
    y: 106.73,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "156.68px 108.495px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 154.18,
    y: 111.91,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "156.68px 113.675px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 154.18,
    y: 117.09,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "156.68px 118.855px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 154.18,
    y: 122.27,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "156.68px 124.035px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 137.5,
    y: 127.39,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "140px 129.155px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 144.95,
    y: 127.39,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "147.45px 129.155px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 154.18,
    y: 127.39,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "156.68px 129.155px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 137.5,
    y: 132.51,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "140px 134.275px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 144.95,
    y: 132.51,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "147.45px 134.275px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 154.18,
    y: 132.51,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "156.68px 134.275px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 137.5,
    y: 137.63,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "140px 139.395px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 144.95,
    y: 137.63,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "147.45px 139.395px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 154.18,
    y: 137.63,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "156.68px 139.395px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 137.5,
    y: 142.75,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "140px 144.515px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 144.95,
    y: 142.75,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "147.45px 144.515px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 154.18,
    y: 142.75,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "156.68px 144.515px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 137.5,
    y: 147.86,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "140px 149.625px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 144.95,
    y: 147.86,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "147.45px 149.625px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 154.18,
    y: 147.86,
    width: 5,
    height: 3.53,
    fill: "#fff",
    style: {
      transformOrigin: "156.68px 149.625px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 201.61,
    y: 91.04,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "202.96px 92.585px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 206.29,
    y: 91.04,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "207.64px 92.585px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 201.61,
    y: 95.69,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "202.96px 97.235px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 206.29,
    y: 95.69,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "207.64px 97.235px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 201.61,
    y: 100.34,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "202.96px 101.885px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 206.29,
    y: 100.34,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "207.64px 101.885px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 201.61,
    y: 104.99,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "202.96px 106.535px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 206.29,
    y: 104.99,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "207.64px 106.535px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 201.61,
    y: 109.75,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "202.96px 111.295px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 206.29,
    y: 109.75,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "207.64px 111.295px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 201.61,
    y: 114.51,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "202.96px 116.055px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 206.29,
    y: 114.51,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "207.64px 116.055px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 201.61,
    y: 119.27,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "202.96px 120.815px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 206.29,
    y: 119.27,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "207.64px 120.815px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 201.61,
    y: 124.04,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "202.96px 125.585px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 206.29,
    y: 124.04,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "207.64px 125.585px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 201.61,
    y: 128.85,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "202.96px 130.395px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 206.29,
    y: 128.85,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "207.64px 130.395px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 201.61,
    y: 133.66,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "202.96px 135.205px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 206.29,
    y: 133.66,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "207.64px 135.205px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 201.61,
    y: 138.48,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "202.96px 140.025px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 206.29,
    y: 138.48,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "207.64px 140.025px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 201.61,
    y: 143.29,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "202.96px 144.835px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 206.29,
    y: 143.29,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "207.64px 144.835px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 211.61,
    y: 91.04,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "212.96px 92.585px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 216.29,
    y: 91.04,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "217.64px 92.585px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 211.61,
    y: 95.69,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "212.96px 97.235px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 216.29,
    y: 95.69,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "217.64px 97.235px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 211.61,
    y: 100.34,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "212.96px 101.885px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 216.29,
    y: 100.34,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "217.64px 101.885px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 211.61,
    y: 104.99,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "212.96px 106.535px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 216.29,
    y: 104.99,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "217.64px 106.535px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 211.61,
    y: 109.75,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "212.96px 111.295px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 216.29,
    y: 109.75,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "217.64px 111.295px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 211.61,
    y: 114.51,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "212.96px 116.055px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 216.29,
    y: 114.51,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "217.64px 116.055px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 211.61,
    y: 119.27,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "212.96px 120.815px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 216.29,
    y: 119.27,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "217.64px 120.815px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 211.61,
    y: 124.04,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "212.96px 125.585px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 216.29,
    y: 124.04,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "217.64px 125.585px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 211.61,
    y: 128.85,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "212.96px 130.395px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 216.29,
    y: 128.85,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "217.64px 130.395px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 211.61,
    y: 133.66,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "212.96px 135.205px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 216.29,
    y: 133.66,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "217.64px 135.205px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 211.61,
    y: 138.48,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "212.96px 140.025px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 216.29,
    y: 138.48,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "217.64px 140.025px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 211.61,
    y: 143.29,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "212.96px 144.835px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 216.29,
    y: 143.29,
    width: 2.7,
    height: 3.09,
    fill: "#fff",
    style: {
      transformOrigin: "217.64px 144.835px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M89.62,63V167.81H410.38V63Zm317.5,101.56H92.88V66.25H407.12Z",
    fill: "#dbdbdb",
    style: {
      transformOrigin: "250px 115.405px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 248.37,
    y: 66.25,
    width: 3.27,
    height: 98.29,
    fill: "#dbdbdb",
    style: {
      transformOrigin: "250.005px 115.395px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "249.95px 432.68px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "animable",
    cx: 249.95,
    cy: 432.68,
    rx: 211.79,
    ry: 22.1,
    fill: "#ebebeb",
    style: {
      transformOrigin: "249.95px 432.68px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "71.445px 314.915px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m74.43 312.68c5.11-10.51 14.06-15.91 24.14-12.93s11.65 17 4.12 20.6-15-6.82-19-9-9.26 1.33-9.26 1.33z",
    fill: "#0057ff",
    style: {
      transformOrigin: "90.9179px 310.018px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M69.48,340.65c0-1.26.07-2.53.12-3.8.09-2.53.17-5.06.27-7.59.17-4.62.67-9.16,2.58-13.43a20.88,20.88,0,0,1,8.11-9.35,17.12,17.12,0,0,1,4.27-1.84,10,10,0,0,1,5-2.73,20.4,20.4,0,0,1,7.1-.18c.08,0,.08.14,0,.13a17.32,17.32,0,0,0-6.72.48,14.52,14.52,0,0,0-2.7,1.05,12.55,12.55,0,0,0-1.56,1,14.39,14.39,0,0,1,6.16.06,13.72,13.72,0,0,1,2.14.7A6.37,6.37,0,0,1,95.9,305a9.48,9.48,0,0,1,2.18.31,16.65,16.65,0,0,1,4.15,1.81c.08,0,0,.16-.07.12a15.37,15.37,0,0,0-4-1.53,13.21,13.21,0,0,0-2.08-.31c-.39,0-.77,0-1.16,0a13.38,13.38,0,0,1,6.52,6.5c0,.08-.08.14-.11.07A12.29,12.29,0,0,0,93,305.32l-.68-.13a9.07,9.07,0,0,1,.11,1c.07.51.15,1,.26,1.53a24.79,24.79,0,0,0,.82,3.07,23.43,23.43,0,0,0,1.22,3,13.83,13.83,0,0,0,1.7,2.87.06.06,0,1,1-.1.08c-.61-.95-1.31-1.82-1.87-2.81A21,21,0,0,1,93.07,311a19.47,19.47,0,0,1-.9-3.15q-.17-.86-.27-1.71a3.64,3.64,0,0,1-.06-1,13.84,13.84,0,0,0-3.58-.08,19.48,19.48,0,0,0,2.33,7.3c0,.07-.08.14-.12.06a29.5,29.5,0,0,1-1.73-3.58,13.38,13.38,0,0,1-.86-3.74,16.4,16.4,0,0,0-5.92,2,19.54,19.54,0,0,0-7.89,8.62A32.58,32.58,0,0,0,71.15,328c-.33,5.37-.4,10.78-.94,16.14,0,.35-.59.46-.66.07A18.82,18.82,0,0,1,69.48,340.65Z",
    fill: "#263238",
    style: {
      transformOrigin: "85.8452px 322.979px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M81.3,305.64a5.63,5.63,0,0,1,1.16-1.07,15.37,15.37,0,0,1,1.3-1,9.72,9.72,0,0,1,2.9-1.35.07.07,0,0,1,0,.13,7.74,7.74,0,0,0-2.86,1.41c-.43.31-.84.65-1.24,1a7.93,7.93,0,0,1-1.17,1C81.34,305.81,81.24,305.72,81.3,305.64Z",
    fill: "#263238",
    style: {
      transformOrigin: "83.9927px 303.997px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m97.61 309.45a30.43 30.43 0 0 1 2.35 3.1 18.68 18.68 0 0 1 1.74 3.45s0 0.06-0.06 0a41.38 41.38 0 0 0-4.12-6.49c-0.06-0.03 0.04-0.13 0.09-0.06z",
    fill: "#263238",
    style: {
      transformOrigin: "99.6007px 312.726px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m86.61 308.41a7.58 7.58 0 0 0 0.58 1.9 12.38 12.38 0 0 0 1 1.69s0 0.07-0.06 0a6.87 6.87 0 0 1-1.63-3.6c-0.03-0.04 0.1-0.08 0.11 0.01z",
    fill: "#263238",
    style: {
      transformOrigin: "87.3428px 310.193px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m70.19 312.93s-7.19-9.1-21.19-5.87c-13.29 3.07-19.42 27.42-6 30.34s11-19.63 15.93-23.4c3.59-2.86 8.75-2.26 11.26-1.07z",
    fill: "#0057ff",
    style: {
      transformOrigin: "52.8371px 322.013px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M38.18,320.36a27.85,27.85,0,0,1,2.88-2.21,13,13,0,0,1,3.07-1.53A19.56,19.56,0,0,1,46,314.28a17.89,17.89,0,0,1,4.23-3.36l-.42,0a20.55,20.55,0,0,0-2.22,0A12.36,12.36,0,0,0,43.23,312a.07.07,0,0,1-.06-.12,19.63,19.63,0,0,1,4.31-1.29,11.33,11.33,0,0,1,2.18-.19,11.48,11.48,0,0,1,1.17.07h.23a19,19,0,0,1,4-1.48l-.38-.1a18.39,18.39,0,0,0-2.08-.34,16.25,16.25,0,0,0-4.18.06c-.08,0-.11-.12,0-.13a27.12,27.12,0,0,1,4.23-.17,17.49,17.49,0,0,1,3.51.45,19.7,19.7,0,0,1,2.55-.29c4.87-.2,10.18,1.62,13.18,5.62s3.59,9.36,4.12,14.2a106.87,106.87,0,0,1,.53,20.31c0,.4-.59.33-.6,0-.18-5.75-.39-11.49-.94-17.21-.25-2.65-.53-5.31-1-7.94a23.68,23.68,0,0,0-1.93-6.54,12,12,0,0,0-4.72-5.07,15.84,15.84,0,0,0-6.68-2,17.65,17.65,0,0,0-6.27.59,4.22,4.22,0,0,1,0,1.23,6.7,6.7,0,0,1-.31,1.53,8.08,8.08,0,0,1-.58,1.35c-.26.48-.59.91-.87,1.37-.05.07-.17,0-.11-.08A6.28,6.28,0,0,0,53.68,313a11.45,11.45,0,0,0,.17-1.42c0-.36,0-.73,0-1.09a18.48,18.48,0,0,0-6.1,3.23c-.34.27-.67.56-1,.85A6.57,6.57,0,0,1,48,316a14.91,14.91,0,0,1,1.24,2.21,19.07,19.07,0,0,1,1.29,4.86c0,.09-.12.11-.13,0a14.27,14.27,0,0,0-1.59-4.61,17.73,17.73,0,0,0-1.24-2.05c-.23-.33-.48-.67-.73-1s-.29-.35-.42-.53a19.28,19.28,0,0,0-4,5.58h0a9.63,9.63,0,0,1,1.64,2.35,22.27,22.27,0,0,1,1.31,2.8,47.09,47.09,0,0,1,1.67,5.7c0,.08-.12.11-.13,0a23.88,23.88,0,0,0-2-5.61c-.41-.88-.85-1.74-1.32-2.59a24.85,24.85,0,0,1-1.31-2.44,18.16,18.16,0,0,0-1.6,6.47c0,.09-.14.07-.13,0a22.59,22.59,0,0,1,3.14-9.94c-.86.37-1.71.72-2.54,1.16a14.71,14.71,0,0,0-2.9,2C38.21,320.52,38.12,320.42,38.18,320.36Z",
    fill: "#263238",
    style: {
      transformOrigin: "57.4775px 328.582px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M48.43,320.88c.42,1.38,1,2.72,1.33,4.11a15.9,15.9,0,0,1,.61,4.11,0,0,0,1,1-.06,0,40.38,40.38,0,0,0-2-8.18A.06.06,0,1,1,48.43,320.88Z",
    fill: "#263238",
    style: {
      transformOrigin: "49.3384px 324.968px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M39.58,317.45a8.09,8.09,0,0,1,1.85-1.32,13.62,13.62,0,0,1,2.14-.76c.08,0,.11.12,0,.14a8.65,8.65,0,0,0-2.07.84,16.16,16.16,0,0,0-1.9,1.17S39.54,317.49,39.58,317.45Z",
    fill: "#263238",
    style: {
      transformOrigin: "41.604px 316.445px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m63.31 300.78s-1.31-16.35-13.49-21.65c-10.15-4.42-16 7-8.78 14 5.8 5.61 15.11 3.06 22.27 7.65z",
    fill: "#0057ff",
    style: {
      transformOrigin: "50.571px 289.46px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M43.28,282.3a51.38,51.38,0,0,1,5.41,2.56,39.09,39.09,0,0,1,4.19,2.79c-.2-.42-.37-.85-.58-1.25a18.55,18.55,0,0,0-1-1.85,16.89,16.89,0,0,0-2.68-3.39c-.06-.06,0-.15.1-.09a27.55,27.55,0,0,1,2.82,3.28,16.78,16.78,0,0,1,1.15,1.85,7.16,7.16,0,0,1,.82,1.88l.13.1a39.5,39.5,0,0,1,5.81,5.68c0-.16-.07-.32-.11-.47-.23-.8-.47-1.59-.74-2.38a20.59,20.59,0,0,0-2.19-4.77c-.05-.07.07-.13.11-.06A38.19,38.19,0,0,1,59,290.83a16.88,16.88,0,0,1,.84,2.42,10.09,10.09,0,0,1,.39,1.64c.53.67,1,1.35,1.54,2.05,5.22,7.42,7.84,16.41,8.47,25.4a77.18,77.18,0,0,1,.13,8.05,49.62,49.62,0,0,1-.71,8.08c0,.17-.3.12-.29-.05.06-2.36.3-4.71.35-7.07s0-4.74-.23-7.1a65.85,65.85,0,0,0-2.65-13.91,49.91,49.91,0,0,0-6.18-13.08c-.51-.1-1-.24-1.52-.37s-1.22-.31-1.82-.48A17.88,17.88,0,0,1,54,295.17c-.08,0,0-.16.07-.12a10.74,10.74,0,0,0,3.44,1.19c1,.19,1.94.31,2.89.53a44.28,44.28,0,0,0-2.83-3.71,21.14,21.14,0,0,1-6.91-.52,29,29,0,0,1-3.54-1.1c-1.22-.47-2.37-1.07-3.57-1.57-.09,0,0-.18,0-.13a20.09,20.09,0,0,0,7,2.3,43.75,43.75,0,0,0,6.56.54c-.86-1-1.76-1.95-2.71-2.86a31.83,31.83,0,0,0-11.19-7.29C43.16,282.4,43.2,282.27,43.28,282.3Z",
    fill: "#263238",
    style: {
      transformOrigin: "56.804px 309.813px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m53.17 282.35a17.86 17.86 0 0 1 1.49 2.18 11.83 11.83 0 0 1 1.08 2.54s0 0-0.05 0c-0.41-0.8-0.75-1.63-1.16-2.43a13 13 0 0 0-1.45-2.21c-0.08-0.05 0.04-0.15 0.09-0.08z",
    fill: "#263238",
    style: {
      transformOrigin: "54.3966px 284.698px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m41.87 287.79a12.61 12.61 0 0 0 2.49 1 22.66 22.66 0 0 0 2.54 0.68s0 0.08 0 0.08a12.49 12.49 0 0 1-2.63-0.58 22.51 22.51 0 0 1-2.46-1.1c-0.08 0-0.01-0.12 0.06-0.08z",
    fill: "#263238",
    style: {
      transformOrigin: "44.3372px 288.666px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m72.76 297.84c0.07 0.7 1.84-5.94 12.11-11.83 9.33-5.36 20.47-19.28 11.32-28.08-7.38-7.1-26.84 8.38-23.43 39.91z",
    fill: "#0057ff",
    style: {
      transformOrigin: "85.9819px 277.06px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M65.68,335.92a185.5,185.5,0,0,1,1.63-20.67,93.1,93.1,0,0,1,4.35-18.49c.76-2.16,1.63-4.29,2.58-6.38a15.36,15.36,0,0,1,0-2.45c0-1,.15-2.09.25-3.13s.2-2.09.32-3.13.35-2.08.39-3.11c0-.1.15-.08.13,0a22.67,22.67,0,0,0-.37,3.3c-.08,1-.13,2-.17,3s0,2,0,3c0,.36,0,.75,0,1.14,1-2,2-4,3.12-6-.69-4.26.21-8.72,1.08-12.88,0-.09.15-.05.13,0a36.58,36.58,0,0,0-.68,6.6c0,1.75,0,3.5.05,5.25.25-.42.49-.84.75-1.26,1.33-2.17,2.75-4.3,4.27-6.37a10,10,0,0,1,.09-3,23.77,23.77,0,0,1,.75-3.32,34,34,0,0,1,1.14-3.21c.44-1.08,1-2.1,1.47-3.18,0-.09.17,0,.12.05A15.56,15.56,0,0,0,85.84,265a26.72,26.72,0,0,0-.84,3.19c-.22,1.08-.4,2.17-.55,3.26-.1.72-.16,1.47-.29,2.2a79.8,79.8,0,0,1,7.2-8.37c.06-.06.15,0,.09.1A95,95,0,0,0,81,279.58l-.33.57c.57-.35,1.22-.63,1.75-.93l3-1.65L88.33,276c.5-.28,1-.56,1.49-.82a12.4,12.4,0,0,0,1.75-1,.07.07,0,1,1,.07.11c-1,.54-1.86,1.35-2.81,2s-1.94,1.2-2.94,1.76c-1.82,1-3.81,1.75-5.61,2.81-1.25,2.18-2.39,4.42-3.46,6.7,1.1-.7,2.21-1.36,3.34-2,.73-.41,1.46-.81,2.2-1.2a10.66,10.66,0,0,0,2.07-1.25c.06-.05.15,0,.09.1a19.39,19.39,0,0,1-4,2.75c-1.32.77-2.65,1.51-4,2.19-1.1,2.4-2.1,4.86-3,7.35-4.32,12.25-5.91,25.25-6.67,38.16-.23,3.85-.34,7.7-.39,11.56s.15,7.69.15,11.54c0,.11-.19.14-.21,0-.46-3.41-.54-6.88-.69-10.32S65.61,339.42,65.68,335.92Z",
    fill: "#263238",
    style: {
      transformOrigin: "78.6544px 309.223px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m84.35 280.47a50.29 50.29 0 0 0 5.46-2.82 56.15 56.15 0 0 0 5.19-3.3s0.06 0 0 0a41.78 41.78 0 0 1-5 3.48 49.49 49.49 0 0 1-5.64 2.71c-0.02 0.08-0.09-0.04-0.01-0.07z",
    fill: "#263238",
    style: {
      transformOrigin: "89.6696px 277.459px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M81.38,266.63c.15-.6.34-1.19.54-1.77,0,0,0,0,0-.07l.4-1,0-.12c0-.06,0-.12.08-.19s0,0,0,0-.06.23-.1.35,0,.12,0,.18a48.8,48.8,0,0,0-1.53,7,.06.06,0,1,1-.12,0A23.16,23.16,0,0,1,81.38,266.63Z",
    fill: "#263238",
    style: {
      transformOrigin: "81.5428px 267.259px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "54.83 338.4 55.56 347.09 57.8 373.6 81.85 373.6 84.09 347.09 84.83 338.4",
    fill: "#455a64",
    style: {
      transformOrigin: "69.83px 356px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "54.83 338.4 55.56 347.09 84.09 347.09 84.83 338.4",
    fill: "#263238",
    style: {
      transformOrigin: "69.83px 342.745px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 52.47,
    y: 334.91,
    width: 34.72,
    height: 8.34,
    fill: "#455a64",
    style: {
      transformOrigin: "69.83px 339.08px",
      transform: "rotate(180deg)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "250px 373.7px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "35.47 373.7 89.1 373.45 142.73 373.37 250 373.2 357.27 373.36 410.9 373.45 464.53 373.7 410.9 373.94 357.27 374.03 250 374.2 142.73 374.03 89.1 373.94",
    fill: "#263238",
    style: {
      transformOrigin: "250px 373.7px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "177.294px 296.84px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "178.9 314.64 181.16 328.19 196.47 410.85 198.93 410.85 187.8 328.19 186.16 314.64",
    fill: "#dbdbdb",
    style: {
      transformOrigin: "188.915px 362.745px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "186.16 314.64 178.9 314.64 181.16 328.19 187.8 328.19",
    fill: "#a6a6a6",
    style: {
      transformOrigin: "183.35px 321.415px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "130.84 410.85 133.3 410.85 148.61 328.19 150.87 314.64 143.61 314.64 141.97 328.19",
    fill: "#dbdbdb",
    style: {
      transformOrigin: "140.855px 362.745px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "143.61 314.64 141.97 328.19 148.61 328.19 150.87 314.64",
    fill: "#a6a6a6",
    style: {
      transformOrigin: "146.42px 321.415px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "84.93 410.85 87.39 410.85 102.7 328.19 104.96 314.64 97.7 314.64 96.06 328.19",
    fill: "#dbdbdb",
    style: {
      transformOrigin: "94.945px 362.745px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "96.06 328.19 102.7 328.19 104.96 314.64 97.7 314.64",
    fill: "#a6a6a6",
    style: {
      transformOrigin: "100.51px 321.415px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "88.84 321 200.99 321 200.99 309.19 159.01 309.19 144.9 227.09 93.11 227.09",
    fill: "#dbdbdb",
    style: {
      transformOrigin: "144.915px 274.045px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "88.84 321 94.95 321 98.94 227.09 93.11 227.09",
    fill: "#a6a6a6",
    style: {
      transformOrigin: "93.89px 274.045px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m124.74 194.33c-2.24 8.84-6.41 19.06-4.37 28.28 1.61 7.23 6.93 13 12.79 17.14 12.9 9.2 32.6 14.1 45.44 2.06 5.12-4.81 8.21-16.4 2.51-22-2.93-2.89-6.85-4.22-10.46-6a16.62 16.62 0 0 1-9.18-11.14c-2.68-10.08-0.4-16.58 0.77-26.65a7.19 7.19 0 0 0-1.35-5.69 12.86 12.86 0 0 0-5.19-4.46 12.74 12.74 0 0 0-5.81-2.23c-4.47-0.44-9.51 2.74-13.41 4.55s-6.08 4.19-7.23 8.44c-1.59 5.82-3.01 11.77-4.51 17.7z",
    fill: "#263238",
    style: {
      transformOrigin: "151.997px 206.276px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m122.77 198.31c2.57-8 5.29-15.87 8-23.8h0.08c-2 6.59-3.93 13.19-6 19.76s-4.61 12.9-6.1 19.49c-3.33 14.79 10.7 24 23.47 25.84 0.58 0.08 0.38 1-0.2 0.9-11.17-2-23.64-8.51-24.51-21.27-0.51-6.96 3.16-14.41 5.26-20.92z",
    fill: "#263238",
    style: {
      transformOrigin: "130.015px 207.509px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M161.68,175a.12.12,0,0,1,.24.06c-1.3,8.24-3.6,17.73-.41,25.79a21.21,21.21,0,0,0,7.85,9.77c2.81,1.87,6,2.65,9.12,3.94,12,5,8.67,22-1.8,26.72-.22.1-.4-.27-.18-.38,7.46-3.8,11.49-12.65,7.66-20.54-3.07-6.34-11.49-6.26-16.6-10.39C157,201.43,159,186.82,161.68,175Z",
    fill: "#263238",
    style: {
      transformOrigin: "172.829px 208.102px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m269 399.35c-2.07 1.21-65.84 14.55-68.6 13.52-1-0.39-3.52-9.56-6.21-20.73-0.58-2.42-1.17-4.91-1.74-7.45-3.79-16.46-7.41-34-7.41-34l42.63-9 6.24 34.27 1.37 7.52s26.7 5.82 29.6 7.27 6.21 7.39 4.12 8.6z",
    fill: "#ad6359",
    style: {
      transformOrigin: "227.349px 377.308px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m195.23 396.4c2.27 9.16 4.27 16.13 5.18 16.47 2.75 1 66.53-12.31 68.6-13.52s-1.24-7.2-4.12-8.66c-1.79-0.89-12.64-3.45-20.69-5.28 7 1.68 20.15 6.45-7 8.41-22.41 1.63-37.2 2.37-41.97 2.58z",
    fill: "#263238",
    style: {
      transformOrigin: "232.443px 399.167px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M211.88,430c-2.31.65-67.37-2.72-69.77-4.41-.53-.37.07-9.11.81-17,.55-5.85,14.76-46.44,14.76-46.44l43.53,2.12L183.34,406s24.33,12.43,26.76,14.58S214.2,429.33,211.88,430Z",
    fill: "#ad6359",
    style: {
      transformOrigin: "177.449px 396.116px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m142.11 425.56c2.4 1.7 67.46 5.06 69.78 4.42s0.64-7.29-1.78-9.43c-1.14-1-7-4.22-13-7.38 7.48 4.21 19.32 13.6-54.34-3.14-0.65 7.45-1.15 15.19-0.66 15.53z",
    fill: "#263238",
    style: {
      transformOrigin: "177.455px 420.045px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m110.52 303.28c13 14.45 56.54 3 59.14 8.79 2.3 5.07-27.44 86.49-27.44 86.49l47.58 5.13s41.08-89.92 26.39-115.9c-7.92-14-42.87-8.44-64-11-6.36-0.77-9.35-13.89-9.35-13.89h-37.64s-9.51 23.87 5.32 40.38z",
    fill: "#37474f",
    style: {
      transformOrigin: "160.78px 333.295px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m203 279.74-40 30.57c-13.27-0.28-42.31 4.32-52.49-7-14.83-16.51-5.32-40.39-5.32-40.39h37.68s3 13.12 9.35 13.89c14.78 1.77 36.42-0.44 50.78 2.93z",
    fill: "#263238",
    style: {
      transformOrigin: "152.594px 286.961px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M191.62,393.08c-1.31-.42-13.65-1.79-16.37-2.09-5.45-.58-22.59-2.19-25.7-2.18a.08.08,0,0,0,0,.15c2.7.56,13.65,1.84,16.37,2.12,5.45.56,24.18,2.38,25.7,2.23A.12.12,0,0,0,191.62,393.08Z",
    fill: "#263238",
    style: {
      transformOrigin: "170.602px 391.064px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M175.43,307.3c-3.06-1.52-26.25-.77-42.89-2.33-5.42-.5-10.86-1.66-15-5.21a24.83,24.83,0,0,1-7.4-12.2c-1.6-5.69-1.44-11.62-1.16-17.44.06-1.43.16-2.87.25-4.3,0-.08-.14-.1-.15,0-1.26,10.43-2.23,22.08,4.55,31.12a21.75,21.75,0,0,0,12.13,8c10,2.64,47.77,2,49.1,3,1.59,1.22-22.81,75.48-23.29,76.9-.09.26.37.44.49.18C154.46,379.27,178.1,308.63,175.43,307.3Z",
    fill: "#263238",
    style: {
      transformOrigin: "141.909px 325.45px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M217.9,290.3c-2.24-5.69-7.36-9.24-14.89-10.6-.12,0-.11.17,0,.2,6.57,1.92,11.26,4.56,13.85,10.11,1.2,2.59,1.83,6.22,2.14,11.1,1.56,24.31-19.66,79.51-20.09,80.47a.07.07,0,0,0,.13.07C202,376.62,227.16,313.81,217.9,290.3Z",
    fill: "#263238",
    style: {
      transformOrigin: "209.419px 330.694px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m235.1 373.72-36 7.66s28.42-84.83 15.07-95.78c-3.7-3-11.77-4.09-21.36 0-14.31 6.18-30.88 18.79-46.5 23.4-14.63 4.32-32 0.35-38-6.23-12.56-13.82-3.12-39.94-3.12-39.94l51.81-1.9s-0.78 0.63 1.69 2.83c0 0 30.46-6.91 43.69 1.18 23.89 14.58 32.72 108.78 32.72 108.78z",
    fill: "#37474f",
    style: {
      transformOrigin: "168.443px 321.155px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M127.59,265.91a.09.09,0,0,0-.18,0,29.77,29.77,0,0,1-.45,5.81,10,10,0,0,1-2.61,4.82c-2.84,2.88-6.91,3.86-10.64,5-.19.06-.16.41.06.37,4.13-.63,8.48-1.68,11.5-4.78a10,10,0,0,0,2.67-5.2A12.4,12.4,0,0,0,127.59,265.91Z",
    fill: "#263238",
    style: {
      transformOrigin: "120.871px 273.867px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M213.26,284c-5.54-3.47-14.2-.83-18.35.76-.09,0,0,.17,0,.14,3.82-1.37,13.31-3.45,18.38.14,11.72,8.31-4,65.1-14.25,96.36-.17.49.22.36.44-.11,1.69-3.71,15-43.2,18.42-69.33C218.47,307.92,221.24,289,213.26,284Z",
    fill: "#263238",
    style: {
      transformOrigin: "206.849px 332.002px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m231 364.14c-1.09 0-10.43 2-12.49 2.49-4.11 0.93-13.65 3.4-15.87 4.25-0.06 0 0 0.14 0 0.14 2.14-0.21 7.11-1.3 9.16-1.77 4.11-1 18.19-4.34 19.22-4.89 0.13-0.05 0.08-0.22-0.02-0.22z",
    fill: "#263238",
    style: {
      transformOrigin: "216.856px 367.58px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m211.49 282.51c-3.73-2-8.16-2.37-12.3-1.86a43.25 43.25 0 0 0-12.57 3.93c-8.43 3.86-16.46 8.56-24.89 12.4s-17.35 6.79-26.6 7.07c-7.9 0.25-17.91-1.14-23-8.26-7.83-11-3.27-29.84-3.18-31.06 0-0.09-0.12-0.09-0.14 0-6.08 23.22 1.74 32.23 7 36 4.19 3 10.21 3.77 14.19 4.1 9.2 0.78 18.42-1.47 26.94-4.87 8.74-3.48 16.94-8.16 25.31-12.45 8-4.1 17-8.34 26.14-6a23.36 23.36 0 0 1 3.05 1.05s0.1-0.02 0.05-0.05z",
    fill: "#263238",
    style: {
      transformOrigin: "159.051px 284.824px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M142.44,216.16c10.76,14.64,25.78,28.71,32.35,28.81,5.3.09,37.92-17.38,40.3-20.16,2-2.39-11.93-22.33-15.08-21.16-5.29,2-24.46,16.3-26,16s-14.19-6.57-26.74-13.24C135.26,200,135,206,142.44,216.16Z",
    fill: "#ad6359",
    style: {
      transformOrigin: "176.36px 224.285px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M211.94,227.09c2.9-1.46,18.67-9.15,21.71-12.12s11.2-12.15,9.17-14.71-4.64-.07-4.64-.07,2.82-4.42.54-6.82-6.21,1.62-6.21,1.62,2.58-4.75.13-7-5.72,2.48-5.72,2.48,2.56-4.24-.24-5.22c-3.35-1.18-7.18,7.16-10.79,10.18-.82.69-17.61,12.75-17.61,12.75Z",
    fill: "#ad6359",
    style: {
      transformOrigin: "220.71px 206.113px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m227.21 190.09c-2.83 6.13-5.13 8.32-10.71 11.94-0.1 0.07 0 0.24 0.1 0.18 5.78-3 9.06-5.37 10.91-12 0.09-0.32-0.17-0.41-0.3-0.12z",
    fill: "#263238",
    style: {
      transformOrigin: "221.994px 196.069px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m232.73 194.5c-3.5 6.11-6 8.51-11.53 12.73-0.08 0.05 0 0.19 0.1 0.14 5.8-3.68 9-6.08 11.71-12.64 0.12-0.3-0.12-0.51-0.28-0.23z",
    fill: "#263238",
    style: {
      transformOrigin: "227.105px 200.875px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m237.89 200.39c-3.81 5.67-6.41 8.42-12.33 11.82a0.12 0.12 0 0 0 0.11 0.22c6.38-2.87 9.64-6.28 12.38-11.9 0.18-0.39 0.08-0.53-0.16-0.14z",
    fill: "#263238",
    style: {
      transformOrigin: "231.817px 206.3px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 205.72,
    y: 169.85,
    width: 55.18,
    height: 38.93,
    fill: "#ebebeb",
    style: {
      transformOrigin: "233.31px 189.315px",
      transform: "rotate(-5.86deg)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M209.3,177.41,231.84,175c7.52-.75,15-1.53,22.55-2.25-7.51.82-15,1.58-22.54,2.37Z",
    fill: "#c7c7c7",
    style: {
      transformOrigin: "231.845px 175.08px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M209.49,179.25,232,176.87c7.52-.75,15-1.53,22.55-2.25-7.51.82-15,1.58-22.54,2.37Z",
    fill: "#c7c7c7",
    style: {
      transformOrigin: "232.02px 176.935px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M209.68,181.09l22.54-2.38c7.51-.75,15-1.53,22.55-2.25-7.51.82-15,1.58-22.54,2.37Z",
    fill: "#c7c7c7",
    style: {
      transformOrigin: "232.225px 178.775px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M209.87,182.92l22.54-2.37c7.51-.75,15-1.54,22.55-2.26-7.51.83-15,1.59-22.54,2.38Z",
    fill: "#c7c7c7",
    style: {
      transformOrigin: "232.415px 180.605px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M210.05,184.76l22.54-2.37c7.52-.75,15-1.54,22.56-2.26-7.51.83-15,1.59-22.54,2.38Z",
    fill: "#c7c7c7",
    style: {
      transformOrigin: "232.6px 182.445px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M210.24,186.6l22.54-2.37c7.52-.75,15-1.54,22.56-2.26-7.51.83-15,1.58-22.54,2.38Z",
    fill: "#c7c7c7",
    style: {
      transformOrigin: "232.79px 184.285px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M210.43,188.44,233,186.07c7.52-.75,15-1.54,22.56-2.26-7.51.82-15,1.58-22.55,2.38Z",
    fill: "#c7c7c7",
    style: {
      transformOrigin: "232.995px 186.125px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M210.62,190.28l22.54-2.38c7.52-.75,15-1.53,22.55-2.25-7.51.82-15,1.58-22.54,2.37Z",
    fill: "#c7c7c7",
    style: {
      transformOrigin: "233.165px 187.965px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M210.81,192.12l22.54-2.38c7.52-.75,15-1.53,22.55-2.25-7.51.82-15,1.58-22.54,2.37Z",
    fill: "#c7c7c7",
    style: {
      transformOrigin: "233.355px 189.805px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M211,194l22.54-2.38c7.52-.75,15-1.53,22.55-2.25-7.51.82-15,1.58-22.54,2.37Z",
    fill: "#c7c7c7",
    style: {
      transformOrigin: "233.545px 191.685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M211.19,195.8l22.54-2.38c7.52-.75,15-1.53,22.55-2.25-7.51.82-15,1.58-22.54,2.37Z",
    fill: "#c7c7c7",
    style: {
      transformOrigin: "233.735px 193.485px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M211.38,197.63l22.54-2.37c7.51-.75,15-1.53,22.55-2.25-7.51.82-15,1.58-22.54,2.37Z",
    fill: "#c7c7c7",
    style: {
      transformOrigin: "233.925px 195.32px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M211.56,199.47l22.55-2.37c7.51-.75,15-1.54,22.55-2.26-7.51.83-15,1.59-22.54,2.38Z",
    fill: "#c7c7c7",
    style: {
      transformOrigin: "234.11px 197.155px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M211.75,201.31l22.54-2.37c7.52-.75,15-1.54,22.56-2.26-7.51.83-15,1.58-22.54,2.38Z",
    fill: "#c7c7c7",
    style: {
      transformOrigin: "234.3px 198.995px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M211.94,203.15l22.54-2.37c7.52-.75,15-1.54,22.56-2.26-7.51.82-15,1.58-22.55,2.38Z",
    fill: "#c7c7c7",
    style: {
      transformOrigin: "234.49px 200.835px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 216.15,
    y: 189.57,
    width: 3.44,
    height: 15.09,
    fill: "#0057ff",
    style: {
      transformOrigin: "217.87px 197.115px",
      transform: "rotate(-5.86deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 222.17,
    y: 182.56,
    width: 3.44,
    height: 21.48,
    fill: "#455a64",
    style: {
      transformOrigin: "223.89px 193.3px",
      transform: "rotate(-5.86deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 228.75,
    y: 186.49,
    width: 3.44,
    height: 16.88,
    fill: "#a6a6a6",
    style: {
      transformOrigin: "230.47px 194.93px",
      transform: "rotate(-5.86deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 234.8,
    y: 180.25,
    width: 3.44,
    height: 22.49,
    fill: "#0057ff",
    style: {
      transformOrigin: "236.52px 191.495px",
      transform: "rotate(-5.86deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 241.3,
    y: 182.6,
    width: 3.44,
    height: 19.47,
    fill: "#455a64",
    style: {
      transformOrigin: "243.02px 192.335px",
      transform: "rotate(-5.76789deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 248.21,
    y: 192.96,
    width: 3.44,
    height: 8.44,
    fill: "#a6a6a6",
    style: {
      transformOrigin: "249.93px 197.18px",
      transform: "rotate(-5.86deg)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M210.39,176l.84,7.29.82,7.28c.54,4.86,1,9.72,1.56,14.59l-.25-.2,11-1.14,11-1.1,11-1.05,11-1-11,1.25-11,1.2-11,1.15-11,1.12-.22,0,0-.22q-.74-7.29-1.43-14.59l-.68-7.3Z",
    fill: "#c7c7c7",
    style: {
      transformOrigin: "233.875px 190.695px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 217.1,
    y: 206.17,
    width: 3.44,
    height: 0.31,
    fill: "#c7c7c7",
    style: {
      transformOrigin: "218.82px 206.325px",
      transform: "rotate(-5.86deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 223.44,
    y: 205.52,
    width: 3.44,
    height: 0.31,
    fill: "#c7c7c7",
    style: {
      transformOrigin: "225.16px 205.675px",
      transform: "rotate(-5.86deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 229.78,
    y: 204.87,
    width: 3.44,
    height: 0.31,
    fill: "#c7c7c7",
    style: {
      transformOrigin: "231.5px 205.025px",
      transform: "rotate(-5.86deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 236.13,
    y: 204.22,
    width: 3.44,
    height: 0.31,
    fill: "#c7c7c7",
    style: {
      transformOrigin: "237.85px 204.375px",
      transform: "rotate(-5.86deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 242.47,
    y: 203.57,
    width: 3.44,
    height: 0.31,
    fill: "#c7c7c7",
    style: {
      transformOrigin: "244.19px 203.725px",
      transform: "rotate(-5.86deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 248.81,
    y: 202.91,
    width: 3.44,
    height: 0.31,
    fill: "#c7c7c7",
    style: {
      transformOrigin: "250.53px 203.065px",
      transform: "rotate(-5.86deg)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m192.92 207.91s3.11-7.87 5.24-11 14.38-12 16.44-9.45c2.66 3.28-3.41 9.77-6.8 12.56 0 0 6.15 7.58 2.8 13.19s-17.68-5.3-17.68-5.3z",
    fill: "#ad6359",
    style: {
      transformOrigin: "204.088px 200.91px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M215,188.58c.26,4.74-4.42,8.12-7.51,11.07a.4.4,0,0,0,.07.64c2.37,3.35,4.74,8.76,3.26,12.83a.1.1,0,0,0,.18.08c2.18-4.15.29-9.66-2.54-13.16,3.21-3,7.76-6.57,6.58-11.46C215.08,188.55,215,188.55,215,188.58Z",
    fill: "#263238",
    style: {
      transformOrigin: "211.296px 200.901px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m189.05 209.13 18.48 25.32s-26.82 12.77-33.53 11.16-14.88-7.93-30.87-28.17c-12.67-16-2-15.65 6.11-11 6.67 3.76 23.64 12.43 25 11.89s14.81-9.2 14.81-9.2z",
    fill: "#0057ff",
    style: {
      transformOrigin: "172.405px 224.701px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M207.53,234.46S183.27,246,175.1,245.75a6.27,6.27,0,0,1-1.13-.13c-6.74-1.62-14.88-8-30.88-28.19-5.6-7.09-6.65-11-5.37-12.69,1.63-2.16,6.94-.92,11.49,1.66,6.66,3.76,23.64,12.44,25,11.89S189,209.13,189,209.13Z",
    fill: "#0057ff",
    style: {
      transformOrigin: "172.381px 224.693px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M184.63,213.69c2.48,3.9,5.15,7.7,7.88,11.42,1.35,1.83,2.69,3.67,4.1,5.44s3,3.62,4.51,5.48c.06.08.2,0,.14-.09-1.4-1.9-2.65-3.9-4-5.83s-2.66-3.68-4-5.51c-2.74-3.74-5.49-7.47-8.35-11.1A.17.17,0,1,0,184.63,213.69Z",
    fill: "#263238",
    style: {
      transformOrigin: "192.933px 224.737px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m196.29 239.42c-7.48 3.1-16.73 6.47-21.19 6.33a6.17 6.17 0 0 1-1.13-0.13c-6.74-1.62-14.88-8-30.88-28.19-3.85-4.88-5.55-8.23-5.82-10.41 9.95 5.43 41.13 22.56 59.02 32.4z",
    opacity: 0.1,
    style: {
      transformOrigin: "166.78px 226.387px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m159.13 251.88v13.2s-15.65 0.95-54.13-0.93c0 0 10.12-40.68 23.89-55.34 6.89-7.33 14.89-6.7 19.93-1.47 1.28 1.32 12.67 22.72 14.22 30.51 1.33 6.88-3.91 14.03-3.91 14.03z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "134.128px 234.34px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M146.05,211.54c1.17,3.28,2.28,6.58,3.29,9.91s2,6.67,2.81,10.07c.41,1.7.79,3.41,1.07,5.15a14.43,14.43,0,0,1-.13,5.36,26.36,26.36,0,0,1-4.44,9.59l.08-.26c0,2.32-.11,4.65-.16,7s-.18,4.65-.31,7q-.18-3.49-.26-7c0-2.33-.13-4.66-.14-7v-.13l.09-.13a25.18,25.18,0,0,0,4.17-9.26c.81-3.32-.12-6.72-.83-10.11s-1.63-6.74-2.53-10.1Z",
    fill: "#263238",
    style: {
      transformOrigin: "149.73px 238.45px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M152.88,225a.87.87,0,0,1-.73.93.79.79,0,0,1-.83-.78.86.86,0,0,1,.73-.93A.79.79,0,0,1,152.88,225Z",
    fill: "#263238",
    style: {
      transformOrigin: "152.1px 225.075px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M155.46,234.8a.85.85,0,0,1-.72.93.79.79,0,0,1-.83-.78.85.85,0,0,1,.72-.93A.77.77,0,0,1,155.46,234.8Z",
    fill: "#263238",
    style: {
      transformOrigin: "154.685px 234.874px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M155,244.51a.86.86,0,0,1-.73.93.79.79,0,0,1-.83-.78.87.87,0,0,1,.73-.93A.79.79,0,0,1,155,244.51Z",
    fill: "#263238",
    style: {
      transformOrigin: "154.22px 244.585px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M151.55,252.26a.87.87,0,0,1-.73.93.78.78,0,0,1-.83-.78.86.86,0,0,1,.73-.93A.79.79,0,0,1,151.55,252.26Z",
    fill: "#263238",
    style: {
      transformOrigin: "150.77px 252.335px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M151.76,261.1a.85.85,0,0,1-.72.93.79.79,0,0,1-.83-.78.86.86,0,0,1,.73-.93A.78.78,0,0,1,151.76,261.1Z",
    fill: "#263238",
    style: {
      transformOrigin: "150.986px 261.175px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m137.42 203.63s5.07 25.37 5.65 30.37 0 32.77 0 32.77l-39.82-2.12s9.15-33.26 18.62-47.76 15.55-13.26 15.55-13.26z",
    fill: "#0057ff",
    style: {
      transformOrigin: "123.289px 235.187px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m146.73 205.31s7.78 17.87 9.09 22.75c3.24 12.12 1.2 38.87 1.2 38.87l3.18-0.48-0.67-14.45s5.19-6.22 3.59-13.57-11-26.33-13.15-29.72-3.24-3.4-3.24-3.4z",
    fill: "#0057ff",
    style: {
      transformOrigin: "155.078px 236.12px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M155.91,220.17c1.2,2.27,2.31,4.59,3.39,6.92-.24-1.09-.53-2.16-.85-3.23a.08.08,0,0,1,.15-.05,15,15,0,0,1,1.06,4.06c.35.76.71,1.51,1.05,2.27.66,1.52,1.35,3,1.87,4.6a15.68,15.68,0,0,1,.76,4.9c0,.09-.15.1-.15,0a17.51,17.51,0,0,0-1.32-4.91c-.6-1.56-1.27-3.1-1.93-4.63-1.41-3.29-2.8-6.58-4.12-9.9C155.8,220.16,155.88,220.12,155.91,220.17Z",
    fill: "#263238",
    style: {
      transformOrigin: "159.578px 229.929px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M202.47,244.21s-4,5.45-.06,7.87,7-3.6,7-3.6Z",
    fill: "#455a64",
    style: {
      transformOrigin: "205.042px 248.432px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m234.19 208.24 0.46-6.59 0.17-2.18-1.89 1.11-5.68 3.42-24.91 40.47 6.94 4.27 24.92-40.47z",
    fill: "#455a64",
    style: {
      transformOrigin: "218.58px 224.105px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "234.66 201.63 234.82 199.46 232.93 200.57",
    fill: "#37474f",
    style: {
      transformOrigin: "233.875px 200.545px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 201.4,
    y: 245.04,
    width: 9.52,
    height: 1.89,
    fill: "#37474f",
    style: {
      transformOrigin: "206.16px 245.985px",
      transform: "rotate(31.4568deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 202.5,
    y: 243.26,
    width: 9.52,
    height: 1.89,
    fill: "#37474f",
    style: {
      transformOrigin: "207.26px 244.205px",
      transform: "rotate(31.62deg)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "203.7 240.91 206.31 242.52 213.88 226.99 212.89 226.45",
    fill: "#37474f",
    style: {
      transformOrigin: "208.79px 234.485px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m128.16 217.05c1.41 18.34 8.87 38.64 18.47 43s38.48 0.26 47.42-1.35c3.44-0.61 0.35-29.58-3.33-28.89-6.23 1.17-33.87 8.37-35.66 7.32-1.11-0.66-9.48-11.52-16.08-22.29-8.58-13.97-11.26-3.49-10.82 2.21z",
    fill: "#ad6359",
    style: {
      transformOrigin: "161.829px 234.945px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m227.43 222.71c0.79 3.4-7.76 4.65-7.76 4.65a6.4 6.4 0 0 1 3.33 2.84c1.2 2.36-2 5.29-2 5.29a7.9 7.9 0 0 1 3 3.56c0.93 2.38-1.86 5.79-1.86 5.79a6.94 6.94 0 0 1 0.71 4.81c-1.11 4.33-7.62 6.41-11.75 7.76s-17.1 1.35-19.58 1.6l-8.95-26.41s16.78-11.36 21.85-12.26c4.36-0.77 21.79-2.83 23.01 2.37z",
    fill: "#ad6359",
    style: {
      transformOrigin: "205.026px 239.147px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M219.58,227.28c-4.75-.28-9.55.58-14.17,1.46a.08.08,0,0,0,0,.16c4.59-.93,9.54-.65,14.15-1.4A.11.11,0,0,0,219.58,227.28Z",
    fill: "#263238",
    style: {
      transformOrigin: "212.505px 228.063px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M220.84,235.17a12.48,12.48,0,0,0-3.2.55q-1.66.41-3.33.87-3.33.91-6.6,2a.08.08,0,0,0,0,.16c2.2-.61,4.42-1.19,6.65-1.7l3.36-.75a15.46,15.46,0,0,0,3.14-.83A.17.17,0,0,0,220.84,235.17Z",
    fill: "#263238",
    style: {
      transformOrigin: "214.285px 236.96px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M222.13,244.86a8.8,8.8,0,0,0-2.85.64c-1,.31-2,.6-3,.89-2,.58-4,1.16-6,1.67a.08.08,0,0,0,0,.16c2.07-.51,4.14-1,6.2-1.51l3-.79a8.19,8.19,0,0,0,2.68-1A.06.06,0,0,0,222.13,244.86Z",
    fill: "#263238",
    style: {
      transformOrigin: "216.18px 246.54px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M198.92,222.65a23.14,23.14,0,0,1,4.33-2.26,20.26,20.26,0,0,1,4.82-1c1.62-.17,3.24-.29,4.87-.32a34.5,34.5,0,0,1,4.87.2c-1.62.1-3.23.23-4.84.38s-3.22.3-4.82.49a28.06,28.06,0,0,0-4.71.78C201.91,221.4,200.42,222,198.92,222.65Z",
    fill: "#263238",
    style: {
      transformOrigin: "208.365px 220.852px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m182.28 230.44 4.08 31.79s-32.89 3.53-41.33-1.7-16.03-27.17-17.16-39.31 2.49-21.16 13.15-4.92 13.78 19.93 14.71 20 26.55-5.86 26.55-5.86z",
    fill: "#0057ff",
    style: {
      transformOrigin: "157.016px 235.453px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M186,262.12c-4.94.44-9.86.81-14.82.9s-17.5-.16-22.37-1.3a12.51,12.51,0,0,1-5.86-3.56,26.56,26.56,0,0,1-4.09-5.67c-1.19-2.09-2.27-4.24-3.34-6.39-1.21-2.46-2.35-4.95-3.48-7.44s-2.39-5.26-3.39-7.95c0-.09-.19-.05-.15,0,.86,2.39,1.66,4.8,2.58,7.17.38,1,.78,1.94,1.18,2.91-.26-.34-.52-.68-.79-1-1-1.21-2.09-2.39-3-3.65a.08.08,0,1,0-.12.09c1,1.21,1.86,2.51,2.75,3.8.43.62.87,1.24,1.34,1.85l.66.84.09.12c.28.65.56,1.3.85,1.94,1,2.3,2.1,4.58,3.25,6.83a31.76,31.76,0,0,0,3.78,6,14.16,14.16,0,0,0,5.37,4.3c4.38,1.75,17.34,2.06,22.45,2a128.19,128.19,0,0,0,17.17-1.26C186.4,262.63,186.41,262.09,186,262.12Z",
    fill: "#263238",
    style: {
      transformOrigin: "157.312px 247.287px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M160.49,235.31c-.75.13-3.49.93-4.3.77a3.09,3.09,0,0,1-1.85-1.4l-1.51-2c-.63-.84-1.28-1.67-1.92-2.5,0-.06,0-.13-.07-.2s-.15-.41-.23-.61l-.51-1.2c-.34-.78-.72-1.54-1.08-2.32-.05-.09-.18,0-.14.09.36.79.67,1.61,1,2.42l.29.81c-.11-.13-.21-.27-.31-.4-.51-.65-2.12-2.66-3.09-4-.06-.09-.19,0-.12.1.89,1.19,2.8,4,3.33,4.83,1,1.52,2.09,3,3.17,4.52.82,1.12,1.65,2.53,3.21,2.56a18.71,18.71,0,0,0,4.26-1.21C160.72,235.47,160.61,235.29,160.49,235.31Z",
    fill: "#263238",
    style: {
      transformOrigin: "153.644px 230.756px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M179.2,247.17q-.39-3.46-.86-6.91c-.32-2.38-.84-4.74-1.09-7.12,0-.1-.17-.07-.15,0,.28,2.37.31,4.77.53,7.15s.44,4.62.7,6.92c.54,4.64,1,9.33,1.9,13.92,0,.14.25.12.24,0C180.27,256.48,179.72,251.81,179.2,247.17Z",
    fill: "#263238",
    style: {
      transformOrigin: "178.784px 247.152px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M136.22,205.16c.1,1,4.05,8.09,8.63,8.44,1.49.12,2.47-8,2.47-8l.21-.59,2.92-8.15-9.06-7.55-1.31-1s-.66,2.29-1.44,5.14c0,.13-.08.26-.11.4s-.1.31-.14.46c-.12.43-.25.86-.36,1.3s-.18.65-.25,1-.17.69-.26,1A54.75,54.75,0,0,0,136.22,205.16Z",
    fill: "#ad6359",
    style: {
      transformOrigin: "143.335px 200.956px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m138.64 193.44a17.35 17.35 0 0 0 8.89 11.56l2.92-8.15-9.06-7.55-1.31-1s-0.66 2.29-1.44 5.14z",
    fill: "#263238",
    style: {
      transformOrigin: "144.545px 196.65px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m163.33 183.61c1.15 15.15-7.79 17.56-11.06 17.8-3 0.23-13.1 0.61-15.82-14.34s4-20.29 10.72-21.16 15 2.54 16.16 17.7z",
    fill: "#ad6359",
    style: {
      transformOrigin: "149.631px 183.629px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M160.43,179.48a9.14,9.14,0,0,1-1.05-.14,1.67,1.67,0,0,1-1-.35.54.54,0,0,1-.05-.66,1.37,1.37,0,0,1,1.31-.41,2,2,0,0,1,1.29.61A.58.58,0,0,1,160.43,179.48Z",
    fill: "#263238",
    style: {
      transformOrigin: "159.653px 178.685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M150.38,180.33a9.15,9.15,0,0,0,1-.3,1.71,1.71,0,0,0,1-.49.53.53,0,0,0-.05-.66,1.33,1.33,0,0,0-1.35-.22,1.93,1.93,0,0,0-1.18.79A.58.58,0,0,0,150.38,180.33Z",
    fill: "#263238",
    style: {
      transformOrigin: "151.092px 179.451px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m153 184s-0.08 0.06-0.07 0.1c0.13 1 0.11 2.24-0.79 2.68v0.05c1.09-0.24 1.1-1.83 0.86-2.83z",
    fill: "#263238",
    style: {
      transformOrigin: "152.633px 185.416px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m151.92 183c-1.68 0-1.49 3.39 0.07 3.36s1.33-3.36-0.07-3.36z",
    fill: "#263238",
    style: {
      transformOrigin: "151.903px 184.68px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m151.27 183.26c-0.28 0.2-0.55 0.56-0.9 0.61s-0.74-0.27-1-0.59h-0.05c0 0.65 0.31 1.29 1 1.35s1-0.55 1.17-1.2c0.01-0.09-0.11-0.26-0.22-0.17z",
    fill: "#263238",
    style: {
      transformOrigin: "150.405px 183.934px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m158.7 183.43s0.08 0 0.08 0.09c0 1 0.22 2.23 1.18 2.53v0.06c-1.17-0.11-1.41-1.69-1.26-2.68z",
    fill: "#263238",
    style: {
      transformOrigin: "159.31px 184.77px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m159.57 182.3c1.67-0.21 2 3.14 0.42 3.33s-1.82-3.15-0.42-3.33z",
    fill: "#263238",
    style: {
      transformOrigin: "159.832px 183.964px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m160.29 182.46c0.28 0.15 0.57 0.45 0.89 0.44s0.6-0.39 0.81-0.76c0.08 0.64-0.08 1.33-0.68 1.5s-1-0.35-1.22-1c0.01-0.06 0.08-0.24 0.2-0.18z",
    fill: "#263238",
    style: {
      transformOrigin: "161.05px 182.906px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M153.53,192.34c.25.24.5.57.88.6a2.76,2.76,0,0,0,1.12-.28s.06,0,0,.06a1.39,1.39,0,0,1-1.31.58,1.12,1.12,0,0,1-.83-.91C153.41,192.33,153.49,192.3,153.53,192.34Z",
    fill: "#263238",
    style: {
      transformOrigin: "154.473px 192.816px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M157.61,188.28s.32,1.54.37,2.27c0,.07-.17.11-.42.14h0a3.48,3.48,0,0,1-3.46-1.07c-.06-.06,0-.15.1-.11a5.19,5.19,0,0,0,3.24.69c0-.2-.64-2.61-.53-2.63a6.69,6.69,0,0,1,1.69.26c-.58-3.22-1.67-6.32-2.2-9.53a.1.1,0,0,1,.19-.06,52.93,52.93,0,0,1,2.8,10.17C159.45,188.83,157.91,188.39,157.61,188.28Z",
    fill: "#263238",
    style: {
      transformOrigin: "156.734px 184.487px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M157.39,190.51a4.19,4.19,0,0,1-1.51,1.45,1.9,1.9,0,0,1-1.11.19c-.84-.13-.94-.87-.85-1.52a4.21,4.21,0,0,1,.26-1A5.28,5.28,0,0,0,157.39,190.51Z",
    fill: "#263238",
    style: {
      transformOrigin: "155.642px 190.898px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M155.88,192a1.9,1.9,0,0,1-1.11.19c-.84-.13-.94-.87-.85-1.52A1.9,1.9,0,0,1,155.88,192Z",
    fill: "#ff9abb",
    style: {
      transformOrigin: "154.887px 191.435px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m137.26 186.19c2.45 0.19 3-4.95 3-4.95s5 0 6.63-7.16a11.06 11.06 0 0 1-2.21 5.93s8.79-0.93 12.5-8.29c0 0-1.48 3.75-2.86 5.08a10.32 10.32 0 0 0 5.48-4s1.54 4.25 2.72 5.42c0 0-0.36-15.38-14.61-13.75 0 0-8.92 0.6-12.12 7.66s1.47 14.06 1.47 14.06z",
    fill: "#263238",
    style: {
      transformOrigin: "148.595px 175.272px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M139,186.67s-3.27-4.78-5.43-3.62.25,8.07,2.77,9a2.57,2.57,0,0,0,3.46-1.34Z",
    fill: "#ad6359",
    style: {
      transformOrigin: "136.266px 187.58px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M134.33,185a0,0,0,0,0,0,.07,6.5,6.5,0,0,1,3.31,4.1,1.42,1.42,0,0,0-2.12-.41s0,.11.05.1a1.56,1.56,0,0,1,1.73.57,6.83,6.83,0,0,1,.82,1.41c.08.16.37.08.31-.1v0C138.48,188.45,136.75,185.27,134.33,185Z",
    fill: "#263238",
    style: {
      transformOrigin: "136.384px 187.963px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m147.63 204.76-2.6 6.86-8.63-8.45-2.34 2.83s8.53 13.52 8.57 12.9l2.7-5.92 4.12 4-0.52-10.25z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "141.755px 211.045px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M149.48,211.89c-.14-1.69-.24-3.39-.46-5.07,0-.06-.1-.09-.12,0-.3,1.64.28,8.09.3,9.64h0c-.17-.18-3.82-3.52-3.85-3.47-.59.94-2.57,5.26-2.7,5.65C141.28,216.46,135.56,208,134,206a.06.06,0,0,0-.1.06c1.2,2.28,8.59,13.44,8.69,13.41a67.27,67.27,0,0,0,2.82-6.26,43.86,43.86,0,0,0,4.32,4.27A54.28,54.28,0,0,0,149.48,211.89Z",
    fill: "#263238",
    style: {
      transformOrigin: "141.814px 212.726px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "235.105px 343.23px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 96.03,
    y: 263.54,
    width: 278.15,
    height: 10.6,
    fill: "#37474f",
    style: {
      transformOrigin: "235.105px 268.84px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 96.03,
    y: 270,
    width: 278.15,
    height: 8.74,
    fill: "#455a64",
    style: {
      transformOrigin: "235.105px 274.37px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "106.72 422.92 102.44 422.92 114.91 278.79 125.85 278.79",
    fill: "#455a64",
    style: {
      transformOrigin: "114.145px 350.855px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "125.85 278.8 124.56 288.44 114.08 288.44 114.91 278.8",
    fill: "#263238",
    style: {
      transformOrigin: "119.965px 283.62px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "363.49 422.92 367.77 422.92 355.3 278.79 344.36 278.79",
    fill: "#455a64",
    style: {
      transformOrigin: "356.065px 350.855px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "344.36 278.8 345.64 288.44 356.13 288.44 355.3 278.8",
    fill: "#263238",
    style: {
      transformOrigin: "350.245px 283.62px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "243.4px 244.505px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 195.87,
    y: 260.96,
    width: 57.52,
    height: 2.58,
    fill: "#dbdbdb",
    style: {
      transformOrigin: "224.63px 262.25px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 224.43,
    y: 260.96,
    width: 28.95,
    height: 2.58,
    fill: "#c7c7c7",
    style: {
      transformOrigin: "238.905px 262.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "227.55 263.54 283.6 263.54 290.93 225.47 234.88 225.47",
    fill: "#dbdbdb",
    style: {
      transformOrigin: "259.24px 244.505px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m256.83 244.5a3.07 3.07 0 0 0 3.11 3.41 3.78 3.78 0 0 0 3.71-3.41 3.07 3.07 0 0 0-3.11-3.41 3.79 3.79 0 0 0-3.71 3.41z",
    fill: "#fff",
    style: {
      transformOrigin: "260.24px 244.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "337.443px 304.165px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "332.53 327.89 330.27 341.44 314.97 424.1 312.5 424.1 323.63 341.44 325.28 327.89",
    fill: "#dbdbdb",
    style: {
      transformOrigin: "322.515px 375.995px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "325.28 327.89 332.53 327.89 330.27 341.44 323.63 341.44",
    fill: "#a6a6a6",
    style: {
      transformOrigin: "328.08px 334.665px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "380.6 424.1 378.13 424.1 362.82 341.44 360.57 327.89 367.82 327.89 369.47 341.44",
    fill: "#dbdbdb",
    style: {
      transformOrigin: "370.585px 375.995px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "367.82 327.89 369.47 341.44 362.82 341.44 360.57 327.89",
    fill: "#a6a6a6",
    style: {
      transformOrigin: "365.02px 334.665px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "426.51 424.1 424.04 424.1 408.74 341.44 406.48 327.89 413.73 327.89 415.38 341.44",
    fill: "#dbdbdb",
    style: {
      transformOrigin: "416.495px 375.995px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "415.38 341.44 408.74 341.44 406.48 327.89 413.73 327.89",
    fill: "#a6a6a6",
    style: {
      transformOrigin: "410.93px 334.665px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "422.59 334.26 310.44 334.26 310.44 322.44 352.43 322.44 366.54 240.34 418.32 240.34",
    fill: "#dbdbdb",
    style: {
      transformOrigin: "366.515px 287.3px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "422.59 334.26 416.48 334.26 412.5 240.34 418.32 240.34",
    fill: "#a6a6a6",
    style: {
      transformOrigin: "417.545px 287.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m313.56 440.21c2.28 0.22 64.32-14.56 66.27-16.57 0.24-0.22-1-5.86-2.77-13.55v-0.15c-1.12-4.88-19.19-44.31-19.19-44.31l-40.22 11.21 18.27 36.59s-7.57 5.46-14.06 10.65a87.59 87.59 0 0 0-8.19 7c-1.94 2.42-2.39 8.92-0.11 9.13z",
    fill: "#eb9481",
    style: {
      transformOrigin: "345.943px 402.921px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m313.56 440.21c2.27 0.22 64.32-14.56 66.28-16.57 0.24-0.23-1-5.86-2.78-13.55v-0.15c-0.41-1.81-3.2-8.44-6.51-16-6.62 1.78-30.34 8.19-39 10.86l4.33 8.67s-7.57 5.47-14.06 10.65a89.54 89.54 0 0 0-8.19 7c-1.9 2.38-2.35 8.88-0.07 9.09z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "345.946px 417.076px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M313.36,440.51c2.34.2,64.42-14.75,66.43-16.81.77-.78-.61-10.58-4-21l-40,9.68s-20.44,16.18-22.4,18.68S311,440.3,313.36,440.51Z",
    fill: "#a6a6a6",
    style: {
      transformOrigin: "345.874px 421.606px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m379.79 423.7c-1.34 1.38-29.57 8.52-48.81 13-9.52 2.24-16.85 3.84-17.62 3.77-2.35-0.21-1.93-6.91 0-9.41a93.81 93.81 0 0 1 8-7.05c6.46-5.34 14.41-11.63 14.41-11.63l40-9.68c3.41 10.42 4.79 20.22 4.02 21z",
    fill: "#455a64",
    style: {
      transformOrigin: "345.874px 421.586px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M331,436.74c-9.52,2.24-16.85,3.84-17.62,3.77-2.35-.21-1.93-6.91,0-9.41a93.81,93.81,0,0,1,8-7.05Z",
    fill: "#37474f",
    style: {
      transformOrigin: "321.386px 432.281px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m313.65 437.81c10.35-2.76 52.35-12.92 62.77-14.81 0.08 0 0.1 0 0 0.06-10.19 3-52.26 12.78-62.74 15-0.21-0.06-0.25-0.19-0.03-0.25z",
    fill: "#263238",
    style: {
      transformOrigin: "344.995px 430.53px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m316.83 427.91a8.61 8.61 0 0 1 6.84 1 8.3 8.3 0 0 1 3.66 5c0 0.06-0.1 0.09-0.12 0a9.94 9.94 0 0 0-10.35-5.91c-0.08 0.05-0.11-0.07-0.03-0.09z",
    fill: "#263238",
    style: {
      transformOrigin: "322.056px 430.785px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M332.76,414.25c4.15-1.06,9.33-.75,12.74,2,.13.11,0,.3-.16.26a60.07,60.07,0,0,0-12.53-1.76A.27.27,0,0,1,332.76,414.25Z",
    fill: "#263238",
    style: {
      transformOrigin: "339.083px 415.101px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M329.84,416.28c4.15-1.06,9.34-.75,12.75,2,.13.11,0,.3-.17.26a59.41,59.41,0,0,0-12.53-1.76A.27.27,0,0,1,329.84,416.28Z",
    fill: "#263238",
    style: {
      transformOrigin: "336.168px 417.131px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M326.93,418.31c4.15-1.06,9.33-.75,12.74,2,.13.11,0,.29-.16.26A59.41,59.41,0,0,0,327,418.84.27.27,0,0,1,326.93,418.31Z",
    fill: "#263238",
    style: {
      transformOrigin: "333.228px 419.16px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M324,420.34c4.16-1.06,9.34-.76,12.75,2,.13.11,0,.29-.16.26a58.86,58.86,0,0,0-12.53-1.76A.27.27,0,0,1,324,420.34Z",
    fill: "#263238",
    style: {
      transformOrigin: "330.33px 421.188px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m334.66 414.37 42.7-11.43s-39.85-83.53-36.82-87.81c1.52-2.14 41.54-3.95 53.95-15.13 16.12-14.53 4.39-35.64 4.39-35.64h-44.75s0.81 9.34-0.89 10.8c-1.12 1-54.27 7-59.58 25.19-6.52 22.26 41 114.02 41 114.02z",
    fill: "#263238",
    style: {
      transformOrigin: "348.023px 339.365px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M332.62,405.34a27.52,27.52,0,0,1,3.51-1.33c1.24-.43,2.48-.86,3.72-1.27,2.46-.8,4.92-1.57,7.4-2.28,5-1.44,10-2.86,15-4.16,2.62-.68,8.24-2.17,8.59-2.12.17,0,.21.31.06.36-4.86,1.77-9.8,3.29-14.73,4.82s-9.86,3-14.86,4.33c-1.38.36-2.78.68-4.17,1a33.16,33.16,0,0,1-4.42,1C332.61,405.69,332.47,405.42,332.62,405.34Z",
    fill: "#37474f",
    style: {
      transformOrigin: "351.774px 399.934px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M332.78,311.65a6.79,6.79,0,0,1,3.35-1.15l19.26-3.83c6-1.19,12.06-2.28,18-3.62,4.95-1.1,10-2.55,14.2-5.38a20.81,20.81,0,0,0,8.45-11.78,37,37,0,0,0,.7-14.79c-.15-1.19-.4-2.39-.67-3.57,0-.09.13-.12.15,0,1.91,9.12,2.37,19.76-4.28,27.27-3.24,3.66-7.78,5.89-12.43,7.39a145.41,145.41,0,0,1-16.17,3.64q-9.63,1.9-19.27,3.81c-3.09.61-6.23,1.11-9.29,1.85a3.14,3.14,0,0,0-1.66.79,2.42,2.42,0,0,0-.21,2.25c.36,1.51.81,3,1.29,4.48,3.89,11.94,31.11,68.46,31.85,69.76.08.14-.14.25-.22.12-6.23-10.39-26.52-54-30.77-65.3a71.16,71.16,0,0,1-2.81-8.78C332,313.7,331.86,312.48,332.78,311.65Z",
    fill: "#37474f",
    style: {
      transformOrigin: "364.761px 328.199px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m249.68 444.82c2.19 0.67 65.93-1.46 68.25-3 0.28-0.17 0.2-5.94 0-13.83v-0.16c-0.13-5 0.13-47.76 0.13-47.76l-39.9 0.85-1.26 42.08s-8.51 3.85-15.9 7.64a87.47 87.47 0 0 0-9.42 5.2c-2.36 2.04-4.09 8.34-1.9 8.98z",
    fill: "#eb9481",
    style: {
      transformOrigin: "283.393px 412.508px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m249.68 444.82c2.19 0.67 65.93-1.46 68.25-3 0.28-0.17 0.21-5.94 0-13.83v-0.15-1.06s0-0.52 0-0.77 0-0.76 0-1.14v-14.64l-40.66 0.94-0.37 11.83s-8.5 3.85-15.9 7.64a88.81 88.81 0 0 0-9.41 5.2c-2.36 2.04-4.1 8.34-1.91 8.98z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "283.396px 427.588px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M249.42,445.07c2.26.67,66.08-1.62,68.46-3.24.9-.61,1.51-10.49.24-21.34L277,422s-23.25,11.79-25.67,13.85S247.17,444.41,249.42,445.07Z",
    fill: "#455a64",
    style: {
      transformOrigin: "283.61px 432.84px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m250.25 442.49c10.68-0.65 53.86-2.25 64.47-2.07 0.09 0 0.09 0.06 0 0.07-10.58 0.87-53.76 2.11-64.47 2.17-0.25 0-0.25-0.16 0-0.17z",
    fill: "#263238",
    style: {
      transformOrigin: "282.425px 441.533px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M255.34,433.42a8.58,8.58,0,0,1,6.49,2.38,8.34,8.34,0,0,1,2.59,5.63c0,.06-.11.07-.12,0a10,10,0,0,0-9-7.88A.07.07,0,1,1,255.34,433.42Z",
    fill: "#263238",
    style: {
      transformOrigin: "259.827px 437.441px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M273.66,423.21c4.28-.22,9.3,1.12,12.09,4.52.1.14-.08.29-.21.23a59.39,59.39,0,0,0-11.93-4.22A.27.27,0,0,1,273.66,423.21Z",
    fill: "#263238",
    style: {
      transformOrigin: "279.595px 425.58px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M270.4,424.61c4.28-.21,9.3,1.13,12.09,4.53.1.13-.08.29-.21.22a60,60,0,0,0-11.93-4.22A.27.27,0,0,1,270.4,424.61Z",
    fill: "#263238",
    style: {
      transformOrigin: "276.335px 426.983px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M267.14,426c4.28-.21,9.3,1.12,12.09,4.53.11.13-.08.28-.21.22a59.39,59.39,0,0,0-11.93-4.22A.27.27,0,0,1,267.14,426Z",
    fill: "#263238",
    style: {
      transformOrigin: "273.077px 428.371px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M263.88,427.43c4.28-.21,9.3,1.12,12.09,4.53.11.13-.08.28-.21.22A59.17,59.17,0,0,0,263.83,428,.27.27,0,0,1,263.88,427.43Z",
    fill: "#263238",
    style: {
      transformOrigin: "269.787px 429.801px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M274.94,422l43.9-.83s-2.19-82.16,1.21-86.78c4.52-6.15,70.31-8,83.84-28,12.15-18,.71-42.6.71-42.6H354.74a103.24,103.24,0,0,0,5.08,15.55s-59.69,12.86-75.95,31.77C272.89,323.92,274.94,422,274.94,422Z",
    fill: "#263238",
    style: {
      transformOrigin: "342.134px 342.895px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M351,276.23a23.79,23.79,0,0,1,4.26,1.23c1.45.5,2.87,1.08,4.27,1.71a83.75,83.75,0,0,1,8,4.22.07.07,0,0,1-.07.12c-2.74-1.32-5.56-2.49-8.38-3.61L355,278.28a40,40,0,0,1-4.12-1.68A.2.2,0,0,1,351,276.23Z",
    fill: "#37474f",
    style: {
      transformOrigin: "359.171px 279.872px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M353.58,263.84c.64,2.26,1.2,4.54,1.92,6.77.33,1,.66,2.07,1.08,3.06.35.84.88,1.79,1.87,1.95s1.42-.79,1.31-1.72-.44-2.08-.67-3.09c-.27-1.18-.55-2.35-.8-3.53-.12-.59-.25-1.18-.37-1.77,0-.15-.17-1.28-.26-1.6a.07.07,0,0,1-.07,0h0a.08.08,0,0,1-.07-.05c0-.09,0-.11.06-.17a.09.09,0,0,1,.1,0c.22.12.24.41.32.63.2.57.4,1.14.59,1.71.35,1.08.68,2.16,1,3.25s.61,2.17.92,3.26a5.16,5.16,0,0,1,.29,2.52,1.93,1.93,0,0,1-1.74,1.51,1.55,1.55,0,0,1,.12.22c.11.22.19.45.28.68s.18.47.25.71a2.09,2.09,0,0,1,.08.34c0,.14,0,.27,0,.4a.19.19,0,0,1-.35.13c-.07-.11-.15-.2-.22-.31a1.81,1.81,0,0,1-.18-.37c-.08-.23-.15-.45-.22-.68s-.14-.46-.19-.69,0-.28-.06-.42a2.56,2.56,0,0,1-1.32-.46,4.31,4.31,0,0,1-1.42-2c-.37-.94-.67-1.91-1-2.87a42.31,42.31,0,0,1-1.67-7.29A.21.21,0,0,1,353.58,263.84Z",
    fill: "#37474f",
    style: {
      transformOrigin: "356.999px 271.408px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M383.37,268.53c.24,1.12.41,2.26.7,3.37s.62,2.17,1,3.23a11.75,11.75,0,0,0,1.47,2.89,11.23,11.23,0,0,0,2.28,2.18,18.82,18.82,0,0,0,5.43,2.81,25.8,25.8,0,0,0,3,.79c.53.1,1.06.17,1.59.23a3.3,3.3,0,0,1,1.29.25.27.27,0,0,1,0,.45,4.59,4.59,0,0,1-2.36.14,16.91,16.91,0,0,1-2.54-.37,18.3,18.3,0,0,1-4.83-1.86,15.12,15.12,0,0,1-4.08-3.15,11.33,11.33,0,0,1-2.27-4.61,23,23,0,0,1-.89-6.33C383.16,268.43,383.35,268.4,383.37,268.53Z",
    fill: "#37474f",
    style: {
      transformOrigin: "391.705px 276.704px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M311.49,364.11q.35-10.64,1.13-21.24c.13-1.75.25-3.49.41-5.24a16.77,16.77,0,0,1,.76-4c1-2.69,3.13-4.09,5.77-4.84,3.13-.89,6.37-1.47,9.56-2.08s6.52-1.2,9.79-1.76c6.63-1.12,13.27-2.17,19.86-3.49a158.59,158.59,0,0,0,19.43-5c5.83-2,11.81-4.33,16.4-8.56,9.87-9.09,9.81-23.83,8.2-36.12-.23-1.73-.49-3.46-.75-5.19,0-.09.12-.13.14,0,1,6.92,2.15,13.88,1.66,20.89a34,34,0,0,1-5.06,16.36c-3.28,5-8.27,8.36-13.7,10.74a110.76,110.76,0,0,1-18.5,5.94c-13.07,3.14-26.45,4.71-39.61,7.36-1.62.33-3.24.68-4.86,1a20.58,20.58,0,0,0-4.37,1.31c-3,1.44-3.71,4.39-4,7.42-.66,7.05-1,14.13-1.33,21.2-.6,14.24-.72,28.55-.27,42.8,0,1.76.12,3.52.19,5.28,0,.16-.24.15-.25,0C311.25,392.66,311,378.39,311.49,364.11Z",
    fill: "#37474f",
    style: {
      transformOrigin: "357.604px 336.757px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M276.44,414.87a26,26,0,0,1,3.73-.42c1.3-.12,2.61-.23,3.92-.32,2.58-.18,5.15-.32,7.73-.41,5.2-.17,10.39-.32,15.59-.35,2.71,0,8.52-.09,8.85.05.16.06.13.35,0,.36-5.15.53-10.3.79-15.46,1.07s-10.31.53-15.47.56c-1.43,0-2.86,0-4.29,0a32.52,32.52,0,0,1-4.52-.15C276.34,415.21,276.27,414.91,276.44,414.87Z",
    fill: "#37474f",
    style: {
      transformOrigin: "296.356px 414.386px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M318.05,380c-.27-5.88-.36-11.75-.38-17.63s.11-11.75.39-17.63a69.91,69.91,0,0,1,1-8.83,8.24,8.24,0,0,1,.32-1.12,2.8,2.8,0,0,1,.3-.6,3.36,3.36,0,0,1,.45-.47,8.74,8.74,0,0,1,2-1.12,31.3,31.3,0,0,1,4.26-1.33,137,137,0,0,1,17.39-2.95c-2.89.53-5.78,1.06-8.65,1.67s-5.73,1.22-8.54,2a39.86,39.86,0,0,0-4.12,1.39,7.84,7.84,0,0,0-1.81,1,1.39,1.39,0,0,0-.48.71,7.3,7.3,0,0,0-.27,1,69,69,0,0,0-.86,8.68c-.36,5.85-.47,11.72-.62,17.59Z",
    fill: "#37474f",
    style: {
      transformOrigin: "330.724px 354.16px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m293 303.54a104.63 104.63 0 0 1 15.62-8.46c5.4-2.45 10.94-4.56 16.52-6.55s11.27-3.68 17-5.25 11.47-3 17.26-4.21c-2.84 0.85-5.7 1.58-8.54 2.44s-5.68 1.63-8.5 2.5c-5.65 1.73-11.3 3.47-16.86 5.47s-11.1 4-16.55 6.3c-2.72 1.13-5.42 2.34-8.07 3.63s-5.28 2.64-7.88 4.13z",
    fill: "#37474f",
    style: {
      transformOrigin: "326.2px 291.305px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m359.58 212.14c-4.64 19.67-8.54 34.92-14 38.79-4.39 3.13-32.53 10.24-38 10.9-2.18 0.27-4 0.45-5.27 0.58-3.19 0.33-9.18-20.54-7-23.19 0.5-0.6 2.58-1.13 5.51-1.62 9.88-1.6 30.57-2.59 31.69-3.74s7.16-9.77 15.3-21.05c5.62-7.78 9.21-10.2 11.26-8.17 1.1 1.15 1.4 3.71 0.51 7.5z",
    fill: "#eb9481",
    style: {
      transformOrigin: "327.473px 233.185px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M307.54,261.84A85.08,85.08,0,0,1,297.43,266c-2.76.8-10.76,2.89-11.94-.06-.81-2,3.75-3.8,6.95-5.13,1.68-.7,3.76-2.46,3.27-3.55-.87-1.89-5.21,0-8.06,1.67-5.52,3.2-12.87,9-16.24,6.17-1.27-1.06.21-3,2.37-4.87-3.51,2.2-7.25,4-8.71,2.88a1.85,1.85,0,0,1-.41-2.51,2.47,2.47,0,0,1-2.71-.42c-1.14-1.2-.59-3,.66-4.77a1.32,1.32,0,0,1-1-.68c-2.42-3.69,9.68-14.26,13.86-15.25,12.31-2.92,25.4-1.85,25.4-1.85C305.68,241.48,307.55,261.83,307.54,261.84Z",
    fill: "#eb9481",
    style: {
      transformOrigin: "284.417px 252.453px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M289.44,250.36a20.1,20.1,0,0,0-8.21,3.15c-2.87,2-5.15,4.67-7.81,6.9-.07.06,0,.17.1.11,1.25-1.16,2.62-2.19,3.92-3.29s2.5-2.2,3.83-3.19a20,20,0,0,1,8.18-3.63A0,0,0,1,0,289.44,250.36Z",
    fill: "#263238",
    style: {
      transformOrigin: "281.421px 255.449px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m287.15 245.13a50.2 50.2 0 0 0-9.55 3.31c-3.29 1.67-5.86 4.4-8.39 7q-2.28 2.36-4.45 4.83c-0.06 0.07 0 0.18 0.1 0.11q3.86-4.08 7.94-7.91a26.27 26.27 0 0 1 8.71-5.48c1.85-0.71 3.75-1.27 5.65-1.83 0.04 0.02 0.03-0.04-0.01-0.03z",
    fill: "#263238",
    style: {
      transformOrigin: "275.961px 252.766px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M283.7,240.57c-3.15.64-5.89,1.19-8.67,2.87a44.91,44.91,0,0,0-8.49,7.32c-1.38,1.47-2.71,3-4,4.52-.06.06.05.16.1.1a105,105,0,0,1,9.6-9.5,20.83,20.83,0,0,1,5.36-3.48,37,37,0,0,1,6.11-1.81S283.71,240.56,283.7,240.57Z",
    fill: "#263238",
    style: {
      transformOrigin: "273.116px 247.983px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m306.65 236.71 4.49 25.43s29.29-4.65 36.2-10.89 11.48-31.07 13.28-40.48-3.4-10.77-10.82-1.77-17.19 24-17.94 24.55-25.21 3.16-25.21 3.16z",
    fill: "#0057ff",
    style: {
      transformOrigin: "333.814px 232.536px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "308.48 264.7 315.61 263.3 310.22 234.27 303.3 235.17",
    fill: "#0057ff",
    style: {
      transformOrigin: "309.455px 249.485px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M322.26,258.42a1,1,0,0,1-.39.19.78.78,0,0,1-.71-.22,1,1,0,0,0-1.11-.19,1,1,0,0,0-.41.36l-.28.41c.15-.08.28-.18.42-.27a1,1,0,0,1,.38-.21.78.78,0,0,1,.72.19,1,1,0,0,0,1.09.23,1.07,1.07,0,0,0,.43-.35c.09-.14.19-.27.27-.42A4.21,4.21,0,0,0,322.26,258.42Zm11.07-12.75a.94.94,0,0,1-.39.19.78.78,0,0,1-.71-.22,1,1,0,0,0-1.11-.19,1,1,0,0,0-.41.36l-.28.41c.15-.08.28-.18.42-.27a1.12,1.12,0,0,1,.38-.21.78.78,0,0,1,.72.19,1,1,0,0,0,1.52-.12c.09-.14.19-.27.27-.42C333.6,245.47,333.47,245.58,333.33,245.67Zm2.94-15.55a.94.94,0,0,1-.39.19.78.78,0,0,1-.71-.22,1,1,0,0,0-.58-.28c-.09.13-.17.25-.26.36a.75.75,0,0,1,.56.21,1,1,0,0,0,1.09.23,1.07,1.07,0,0,0,.43-.35c.09-.14.19-.27.27-.42C336.54,229.92,336.41,230,336.27,230.12ZM352.84,239a1,1,0,0,1-.38.19.79.79,0,0,1-.72-.22,1,1,0,0,0-1.11-.2,1.21,1.21,0,0,0-.41.36c-.09.14-.19.27-.27.42.14-.08.27-.18.41-.28a1.27,1.27,0,0,1,.38-.2.77.77,0,0,1,.72.19,1,1,0,0,0,1.1.23,1,1,0,0,0,.42-.35c.09-.14.19-.27.28-.42A3.83,3.83,0,0,0,352.84,239Zm8.09-30.66s0,0,0,.06q0-.3,0-.57A1,1,0,0,0,360.93,208.33Zm-21.28,44.45c0-.16-.06-.33-.1-.49a4.26,4.26,0,0,0-.1.49,1,1,0,0,1-.13.41.76.76,0,0,1-.64.38,1,1,0,0,0-.93.61,1,1,0,0,0-.05.55c0,.16.05.33.09.49a4.26,4.26,0,0,0,.1-.49,1,1,0,0,1,.14-.41.79.79,0,0,1,.66-.35,1,1,0,0,0,.92-.64A1.05,1.05,0,0,0,339.65,252.78Zm-20.23-7.52a4.26,4.26,0,0,0-.1-.49c0,.16-.06.33-.1.49a.86.86,0,0,1-.12.41.77.77,0,0,1-.64.38,1,1,0,0,0-.94.61,1.06,1.06,0,0,0,0,.55c0,.16.06.33.1.49a4.26,4.26,0,0,0,.1-.49.87.87,0,0,1,.14-.41.79.79,0,0,1,.66-.35,1,1,0,0,0,.92-.64A1,1,0,0,0,319.42,245.26Zm19.23-8a4.74,4.74,0,0,0-.1-.49c0,.17-.06.33-.1.49a1,1,0,0,1-.12.42.76.76,0,0,1-.64.37,1,1,0,0,0-.94.61,1,1,0,0,0-.05.55,3.86,3.86,0,0,0,.1.49,3.86,3.86,0,0,0,.1-.49.83.83,0,0,1,.14-.4.74.74,0,0,1,.66-.35,1,1,0,0,0,.92-.65A1,1,0,0,0,338.65,237.28ZM343,220.79c0-.16-.06-.32-.1-.49a4.74,4.74,0,0,0-.1.49,1,1,0,0,1-.12.42.76.76,0,0,1-.64.37,1,1,0,0,0-.94.61,1,1,0,0,0-.05.55,3.86,3.86,0,0,0,.1.49c0-.16.06-.32.1-.49a.94.94,0,0,1,.13-.4.76.76,0,0,1,.66-.35,1,1,0,0,0,.92-.65A1,1,0,0,0,343,220.79Zm10.43,2.39a4.74,4.74,0,0,0-.1-.49c0,.17-.06.33-.1.49a1,1,0,0,1-.12.42.76.76,0,0,1-.64.37,1,1,0,0,0-.94.61,1.06,1.06,0,0,0-.05.55c0,.17.06.33.1.49a3.86,3.86,0,0,0,.1-.49.83.83,0,0,1,.14-.4.74.74,0,0,1,.66-.35,1,1,0,0,0,.92-.65A1,1,0,0,0,353.45,223.18Zm-39.57,29.55a4.26,4.26,0,0,0-.1-.49c0,.16-.06.33-.1.49a1,1,0,0,1-.12.42.79.79,0,0,1-.64.37,1,1,0,0,0-.94.61,1.06,1.06,0,0,0-.05.55,4.26,4.26,0,0,0,.1.49,4.26,4.26,0,0,0,.1-.49.87.87,0,0,1,.14-.41.79.79,0,0,1,.66-.35,1,1,0,0,0,.92-.64A1,1,0,0,0,313.88,252.73ZM317.5,238a.83.83,0,0,1-.38.2.73.73,0,0,1-.71-.19,1,1,0,0,0-1.1-.22.86.86,0,0,0-.42.35c-.1.14-.2.27-.28.41.15-.08.28-.18.42-.27a.8.8,0,0,1,.38-.19.74.74,0,0,1,.71.21,1,1,0,0,0,1.11.2,1,1,0,0,0,.41-.36c.09-.14.2-.27.28-.42C317.77,237.77,317.64,237.88,317.5,238ZM345,245a1.07,1.07,0,0,1-.39.21.76.76,0,0,1-.71-.19,1,1,0,0,0-1.1-.23.91.91,0,0,0-.42.35c-.09.14-.2.27-.28.42.15-.09.28-.19.42-.28a1,1,0,0,1,.38-.19.79.79,0,0,1,.72.22,1,1,0,0,0,1.52-.17c.09-.14.19-.27.27-.42C345.3,244.85,345.17,245,345,245Zm11.4-32.56a1,1,0,0,1-.38.21.75.75,0,0,1-.71-.19,1,1,0,0,0-1.1-.23,1,1,0,0,0-.42.35,3.83,3.83,0,0,0-.28.42c.15-.08.28-.19.42-.28a.91.91,0,0,1,.38-.19.77.77,0,0,1,.71.22,1,1,0,0,0,1.11.19.91.91,0,0,0,.41-.36c.1-.14.2-.27.28-.41C356.71,212.29,356.58,212.39,356.44,212.48Zm-7.11,4.8a.87.87,0,0,1-.4-.14.74.74,0,0,1-.35-.66,1,1,0,0,0-.65-.92,1,1,0,0,0-.54,0,4.42,4.42,0,0,0-.5.1l.5.1a1,1,0,0,1,.41.12.76.76,0,0,1,.37.64,1,1,0,0,0,.62.94,1,1,0,0,0,.54,0l.5-.1A4.42,4.42,0,0,0,349.33,217.28ZM345.6,232a.86.86,0,0,1-.4-.13.74.74,0,0,1-.35-.66,1,1,0,0,0-1.19-1l-.5.1a4.42,4.42,0,0,0,.5.1.86.86,0,0,1,.41.13.73.73,0,0,1,.37.64,1,1,0,0,0,.62.93.92.92,0,0,0,.54.05,4.42,4.42,0,0,0,.5-.1Zm-18.22,21.9a.79.79,0,0,1-.4-.14.77.77,0,0,1-.36-.66,1,1,0,0,0-.64-.92,1,1,0,0,0-.55,0,4.74,4.74,0,0,0-.49.1l.49.09a1,1,0,0,1,.42.13.76.76,0,0,1,.37.64,1,1,0,0,0,.61.93,1,1,0,0,0,.55.06l.49-.1A4.26,4.26,0,0,0,327.38,253.91Zm0-14a.9.9,0,0,1-.4-.13.8.8,0,0,1-.36-.66,1,1,0,0,0-.64-.92,1,1,0,0,0-.55,0,4.74,4.74,0,0,0-.49.1l.49.1a1,1,0,0,1,.42.12.76.76,0,0,1,.37.64,1,1,0,0,0,.61.94,1,1,0,0,0,.55.05,4.26,4.26,0,0,0,.49-.1C327.71,239.94,327.54,239.93,327.38,239.89Z",
    fill: "#fff",
    style: {
      transformOrigin: "336.412px 233.406px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M313.26,248.73q-.63-3-1.3-6c-.44-2-.81-4-1.4-6,0-.09-.18-.08-.17,0,.21,2,.64,3.91,1,5.85s.76,4.1,1.16,6.16c.78,4.05,1.72,8.06,2.73,12.06,0,.1.16.06.15,0C314.79,256.78,314.11,252.74,313.26,248.73Z",
    fill: "#263238",
    style: {
      transformOrigin: "312.91px 248.764px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m360.62 210.77c-1.8 9.41-6.36 34.25-13.27 40.48-3.11 2.81-10.75 5.29-18.21 7.18 7-13.11 25.37-47.46 30-55.32 1.65 0.68 2.31 3.3 1.48 7.66z",
    opacity: 0.1,
    style: {
      transformOrigin: "345.059px 230.77px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m346.26 276.77c1.56 1.24 64.83 0.71 65.09 0.27s-18.65-67.15-42-75c-3.69-1.24-13.25-0.09-14.26 1.32-8.33 11.73-9.81 72.64-8.83 73.41z",
    fill: "#0057ff",
    style: {
      transformOrigin: "378.674px 239.525px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M349.5,221.81c-.47,2.78-.78,5.6-1.07,8.41,0-1.26-.07-2.51-.12-3.77,0-.09-.15-.09-.15,0,0,1.85,0,3.69.09,5.53l0,.28q-.56,5.43-1,10.86c-.61,7.19-1.07,14.4-1.22,21.62-.09,4,0,8.05,0,12.08a.09.09,0,0,0,.17,0c.17-3.59.46-7.18.65-10.76s.38-7.17.58-10.75c.41-7.15.81-14.31,1.34-21.45.29-4,.71-8,.89-12C349.6,221.76,349.5,221.75,349.5,221.81Z",
    fill: "#263238",
    style: {
      transformOrigin: "347.825px 249.327px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M369.91,230.36l.5-.1a1,1,0,0,1,1.19,1,.74.74,0,0,0,.35.66,1,1,0,0,0,.4.14l.5.09a4.42,4.42,0,0,1-.5.1.92.92,0,0,1-.54-.05,1,1,0,0,1-.62-.93.75.75,0,0,0-.37-.64,1,1,0,0,0-.41-.13A4.42,4.42,0,0,1,369.91,230.36Zm9.56,32.52a.86.86,0,0,1,.41.13.76.76,0,0,1,.38.64,1,1,0,0,0,.61.93,1,1,0,0,0,.55.05,4.74,4.74,0,0,0,.49-.1l-.49-.1a.86.86,0,0,1-.41-.13.79.79,0,0,1-.35-.66,1,1,0,0,0-.65-.92,1,1,0,0,0-.54,0l-.49.1A4.26,4.26,0,0,0,379.47,262.88Zm11.28-30.67a1,1,0,0,1,.41.13.77.77,0,0,1,.38.64,1,1,0,0,0,.61.93,1,1,0,0,0,.55.06l.49-.1a4.26,4.26,0,0,0-.49-.1.87.87,0,0,1-.41-.14.79.79,0,0,1-.35-.66,1,1,0,0,0-.64-.92,1,1,0,0,0-.55,0c-.16,0-.33,0-.49.09A4.26,4.26,0,0,0,390.75,232.21Zm-28.84-16.48a1,1,0,0,1,.41.12.77.77,0,0,1,.38.64,1,1,0,0,0,.61.94,1,1,0,0,0,.55,0c.16,0,.33,0,.49-.1a4.26,4.26,0,0,0-.49-.1.87.87,0,0,1-.41-.14.79.79,0,0,1-.35-.66,1,1,0,0,0-1.19-.95,4.26,4.26,0,0,0-.49.1Zm17.75-.38a1,1,0,0,1,.42.13.76.76,0,0,1,.37.64,1,1,0,0,0,.61.93,1,1,0,0,0,.55.06l.49-.1a4.26,4.26,0,0,0-.49-.1.87.87,0,0,1-.41-.14.79.79,0,0,1-.35-.66,1,1,0,0,0-.64-.92,1,1,0,0,0-.55,0,4.26,4.26,0,0,0-.49.1C379.33,215.3,379.5,215.32,379.66,215.35ZM357.55,244a1,1,0,0,1,.42.12.76.76,0,0,1,.37.64,1,1,0,0,0,.61.94,1.06,1.06,0,0,0,.55.05c.16,0,.33-.05.49-.1a4.26,4.26,0,0,0-.49-.1.87.87,0,0,1-.41-.14.79.79,0,0,1-.35-.66,1,1,0,0,0-.64-.92,1,1,0,0,0-.55,0,4.26,4.26,0,0,0-.49.1Zm20.15,29.53a.86.86,0,0,1,.41.13.76.76,0,0,1,.38.64,1,1,0,0,0,.61.93,1,1,0,0,0,.55.05l.49-.09a4.74,4.74,0,0,0-.49-.1,1,1,0,0,1-.41-.14.79.79,0,0,1-.35-.66,1,1,0,0,0-.65-.92,1,1,0,0,0-.54,0l-.49.1A4.26,4.26,0,0,0,377.7,273.56Zm-25.45-3.37a.86.86,0,0,1,.41.13.73.73,0,0,1,.37.64,1,1,0,0,0,.62.93,1,1,0,0,0,.55.05,4.74,4.74,0,0,0,.49-.1l-.49-.09a1,1,0,0,1-.41-.14.74.74,0,0,1-.35-.66,1,1,0,0,0-.65-.92,1,1,0,0,0-.54,0l-.49.1A3.86,3.86,0,0,0,352.25,270.19Zm15.13-12.42a1,1,0,0,1,.41.12.77.77,0,0,1,.38.64,1,1,0,0,0,.61.94,1,1,0,0,0,.55,0,4.74,4.74,0,0,0,.49-.1l-.49-.1a1,1,0,0,1-.41-.13.79.79,0,0,1-.35-.66,1,1,0,0,0-.65-.92.92.92,0,0,0-.54,0,4.26,4.26,0,0,0-.49.1A4.26,4.26,0,0,0,367.38,257.77Zm8.12-13.35a1,1,0,0,1,.41.12.74.74,0,0,1,.37.64,1,1,0,0,0,.62.94.92.92,0,0,0,.54,0,4.42,4.42,0,0,0,.5-.1,4.42,4.42,0,0,0-.5-.1.87.87,0,0,1-.4-.14.74.74,0,0,1-.35-.66,1,1,0,0,0-.65-.91.92.92,0,0,0-.54,0,4.42,4.42,0,0,0-.5.1Zm22.55,21.85a.86.86,0,0,1,.41.13.73.73,0,0,1,.37.64,1,1,0,0,0,.62.93.92.92,0,0,0,.54,0,4.42,4.42,0,0,0,.5-.1l-.5-.1a.86.86,0,0,1-.4-.13.74.74,0,0,1-.35-.66,1,1,0,0,0-1.19-1l-.49.1A3.86,3.86,0,0,0,398.05,266.27Zm-9-13.34a.87.87,0,0,1,.42.13.75.75,0,0,1,.37.63,1,1,0,0,0,.62.94.92.92,0,0,0,.54.05,3.86,3.86,0,0,0,.49-.1l-.49-.1a.94.94,0,0,1-.4-.13.76.76,0,0,1-.35-.66,1,1,0,0,0-.65-.92,1,1,0,0,0-.55,0l-.49.1A4.74,4.74,0,0,0,389.09,252.93Zm19,19.44a1,1,0,0,1,.42.13.75.75,0,0,1,.37.64,1,1,0,0,0,.61.93.88.88,0,0,0,.55.05c.16,0,.33-.05.49-.09a4.26,4.26,0,0,0-.49-.1.9.9,0,0,1-.4-.14.77.77,0,0,1-.36-.66,1,1,0,0,0-.64-.92,1.17,1.17,0,0,0-.55,0l-.49.1A4.26,4.26,0,0,0,408.12,272.37Zm-45.6-47.26a1,1,0,0,1-.38.21.78.78,0,0,1-.72-.19,1,1,0,0,0-1.09-.23,1.07,1.07,0,0,0-.43.35c-.09.14-.19.27-.27.42a4.21,4.21,0,0,0,.41-.28,1,1,0,0,1,.39-.19.78.78,0,0,1,.71.22,1,1,0,0,0,1.11.19,1,1,0,0,0,.41-.36l.28-.41C362.79,224.92,362.66,225,362.52,225.11Zm-6.08-12.63a1.12,1.12,0,0,1-.38.21.78.78,0,0,1-.72-.19,1,1,0,0,0-1.52.12c-.09.14-.19.27-.28.42.15-.08.28-.19.42-.28a1,1,0,0,1,.38-.19.79.79,0,0,1,.72.22,1,1,0,0,0,1.11.19,1,1,0,0,0,.41-.36l.28-.41C356.71,212.29,356.58,212.39,356.44,212.48ZM389,244.18a.94.94,0,0,1-.38.2.73.73,0,0,1-.72-.19,1,1,0,0,0-1.09-.22.94.94,0,0,0-.43.35l-.28.41c.15-.08.28-.18.42-.27a.85.85,0,0,1,.38-.19.77.77,0,0,1,.72.22,1,1,0,0,0,1.11.19,1,1,0,0,0,.41-.36c.09-.14.19-.27.28-.42C389.29,244,389.16,244.09,389,244.18Zm-16.54-35.5a1,1,0,0,1-.38.21.75.75,0,0,1-.71-.19,1,1,0,0,0-1.1-.23.91.91,0,0,0-.42.35,3.83,3.83,0,0,0-.28.42c.15-.09.28-.19.42-.28a.91.91,0,0,1,.38-.19.77.77,0,0,1,.71.22,1,1,0,0,0,1.11.19.91.91,0,0,0,.41-.36c.09-.14.2-.27.28-.42Zm-.32,10.52a1,1,0,0,1-.13.41.75.75,0,0,1-.64.37,1,1,0,0,0-.93.62.93.93,0,0,0-.06.54c0,.17.06.33.1.49a3.86,3.86,0,0,0,.1-.49.87.87,0,0,1,.14-.4.74.74,0,0,1,.66-.35,1,1,0,0,0,1-1.19c0-.17-.05-.33-.09-.5A4.42,4.42,0,0,0,372.16,219.2ZM368.25,248a.87.87,0,0,1-.12.42.76.76,0,0,1-.64.37,1,1,0,0,0-.94.61,1.06,1.06,0,0,0-.05.55c0,.17.06.33.1.49a3.86,3.86,0,0,0,.1-.49.83.83,0,0,1,.14-.4.74.74,0,0,1,.66-.35,1,1,0,0,0,.92-.65,1,1,0,0,0,0-.55,4.74,4.74,0,0,0-.1-.49C368.31,247.68,368.29,247.84,368.25,248Zm37.84,13.35a.86.86,0,0,1-.13.41.76.76,0,0,1-.64.38,1,1,0,0,0-.93.61,1,1,0,0,0-.05.55,4.74,4.74,0,0,0,.1.49c0-.17.06-.33.1-.49a.86.86,0,0,1,.13-.41.77.77,0,0,1,.66-.35,1,1,0,0,0,.92-.65,1,1,0,0,0,0-.54c0-.17-.06-.33-.1-.49A3.86,3.86,0,0,0,406.09,261.35Zm-17.53-38.17a1,1,0,0,1-.13.42.75.75,0,0,1-.64.37,1,1,0,0,0-.93.61,1,1,0,0,0-.06.55c0,.17.06.33.1.49a3.86,3.86,0,0,0,.1-.49.83.83,0,0,1,.14-.4.74.74,0,0,1,.66-.35,1,1,0,0,0,.92-.65,1,1,0,0,0,0-.55c0-.16-.05-.32-.09-.49A4.74,4.74,0,0,0,388.56,223.18Zm0,46.26a1,1,0,0,1-.13.41.76.76,0,0,1-.64.38,1,1,0,0,0-.93.61,1,1,0,0,0-.06.55c0,.16.06.33.1.49a4.26,4.26,0,0,0,.1-.49.87.87,0,0,1,.14-.41.79.79,0,0,1,.66-.35,1,1,0,0,0,.95-1.19c0-.16-.05-.33-.09-.49A4.26,4.26,0,0,0,388.56,269.44Zm8.9-26.49a1,1,0,0,1-.13.42.76.76,0,0,1-.64.37,1,1,0,0,0-.93.61,1,1,0,0,0-.06.55c0,.16.06.33.1.49a4.26,4.26,0,0,0,.1-.49.83.83,0,0,1,.14-.4.74.74,0,0,1,.66-.35,1,1,0,0,0,.92-.65,1,1,0,0,0,0-.55c0-.16,0-.32-.09-.49A4.74,4.74,0,0,0,397.46,243ZM352.37,249a1,1,0,0,1-.12.42.76.76,0,0,1-.64.37,1,1,0,0,0-.94.62.92.92,0,0,0-.05.54,3.86,3.86,0,0,0,.1.49,3.86,3.86,0,0,0,.1-.49.83.83,0,0,1,.14-.4.74.74,0,0,1,.66-.35,1,1,0,0,0,.91-.65,1,1,0,0,0,0-.55,4.74,4.74,0,0,0-.1-.49C352.43,248.71,352.41,248.87,352.37,249Zm.88-25.85a.87.87,0,0,1-.13.42.75.75,0,0,1-.64.37,1,1,0,0,0-.93.61,1,1,0,0,0-.05.55,3.86,3.86,0,0,0,.1.49c0-.16.06-.32.1-.49a.82.82,0,0,1,.13-.4.74.74,0,0,1,.66-.35,1,1,0,0,0,.92-.65,1,1,0,0,0,0-.55c0-.16-.06-.32-.1-.49A4.74,4.74,0,0,0,353.25,223.18Zm9.43-16.8a.86.86,0,0,1-.13.41.76.76,0,0,1-.64.38,1,1,0,0,0-.93.61,1,1,0,0,0-.05.55,4.26,4.26,0,0,0,.1.49c0-.16.06-.33.1-.49a.86.86,0,0,1,.13-.41.79.79,0,0,1,.66-.35,1,1,0,0,0,.92-.64,1.05,1.05,0,0,0,0-.55c0-.16-.06-.33-.1-.49A4.26,4.26,0,0,0,362.68,206.38Zm-2.53,26a1,1,0,0,1-.13.41.76.76,0,0,1-.64.38,1,1,0,0,0-.93.61,1,1,0,0,0-.06.55c0,.16.06.33.1.49a4.26,4.26,0,0,0,.1-.49.87.87,0,0,1,.14-.41.79.79,0,0,1,.66-.35,1,1,0,0,0,.92-.64,1.17,1.17,0,0,0,0-.55c0-.16-.06-.33-.1-.49A4.26,4.26,0,0,0,360.15,232.36Zm22.73,3.49a1,1,0,0,1-.13.42.75.75,0,0,1-.64.37,1,1,0,0,0-.93.61,1,1,0,0,0-.05.55c0,.16.05.33.09.49a4.26,4.26,0,0,0,.1-.49.9.9,0,0,1,.14-.4.77.77,0,0,1,.66-.36,1,1,0,0,0,.92-.64,1.05,1.05,0,0,0,0-.55c0-.16-.06-.33-.1-.49A4.26,4.26,0,0,0,382.88,235.85Zm-21,29.17a.87.87,0,0,1-.13.42.75.75,0,0,1-.64.37,1,1,0,0,0-.93.62.92.92,0,0,0-.05.54,3.86,3.86,0,0,0,.1.49c0-.16.06-.32.1-.49a.86.86,0,0,1,.13-.4.74.74,0,0,1,.66-.35,1,1,0,0,0,.92-.65,1,1,0,0,0,0-.55c0-.16-.06-.32-.1-.49A4.74,4.74,0,0,0,361.87,265Zm-5.79,12.05a1.84,1.84,0,0,0-.07.3h.13C356.12,277.28,356.11,277.17,356.08,277.07Zm15.28-.14c0-.16-.06-.33-.1-.49,0,.16-.06.33-.1.49a.94.94,0,0,1-.13.42.52.52,0,0,1-.15.18h.42l0,0A1,1,0,0,0,371.36,276.93Zm8.14-50.09a1,1,0,0,1,.38-.21.78.78,0,0,1,.72.19,1,1,0,0,0,1.09.23,1.07,1.07,0,0,0,.43-.35c.09-.14.19-.27.27-.42a4.21,4.21,0,0,0-.41.28,1,1,0,0,1-.39.19.78.78,0,0,1-.71-.22,1,1,0,0,0-1.11-.19,1,1,0,0,0-.41.36l-.28.41C379.23,227,379.36,226.93,379.5,226.84Zm-13.26,12a1,1,0,0,1,.38-.21.78.78,0,0,1,.72.19,1,1,0,0,0,1.09.23,1.07,1.07,0,0,0,.43-.35c.09-.14.19-.27.27-.42-.15.09-.28.19-.41.28a1,1,0,0,1-.39.19.78.78,0,0,1-.71-.22,1,1,0,0,0-1.11-.19,1,1,0,0,0-.41.36c-.09.14-.19.27-.28.42C366,239,366.1,238.94,366.24,238.85Zm-9,17.69a.83.83,0,0,1,.38-.2.73.73,0,0,1,.71.19,1,1,0,0,0,1.1.22.91.91,0,0,0,.42-.35c.09-.14.2-.27.28-.41-.15.08-.28.18-.42.27a.8.8,0,0,1-.38.19.77.77,0,0,1-.72-.22,1,1,0,0,0-1.1-.19.91.91,0,0,0-.41.36,3.83,3.83,0,0,0-.28.42C357,256.74,357.12,256.63,357.26,256.54Zm3.88,18.39a1,1,0,0,1,.38-.21.78.78,0,0,1,.72.19,1,1,0,0,0,1.09.23,1.07,1.07,0,0,0,.43-.35c.09-.14.19-.27.27-.42a4.21,4.21,0,0,0-.41.28,1,1,0,0,1-.39.19.78.78,0,0,1-.71-.22,1,1,0,0,0-1.11-.19,1,1,0,0,0-.41.36l-.28.41C360.87,275.12,361,275,361.14,274.93Zm17.38-20.21a.94.94,0,0,1,.38-.2.75.75,0,0,1,.72.19,1,1,0,0,0,1.09.22.88.88,0,0,0,.43-.35l.28-.41c-.15.08-.28.18-.42.27a.83.83,0,0,1-.39.19.75.75,0,0,1-.71-.21,1,1,0,0,0-1.11-.2,1.11,1.11,0,0,0-.41.36c-.09.14-.19.27-.28.42C378.25,254.92,378.38,254.81,378.52,254.72Zm12,7.33a1,1,0,0,1,.38-.21.75.75,0,0,1,.71.19,1,1,0,0,0,1.1.23,1,1,0,0,0,.42-.35c.09-.14.2-.27.28-.42a3.83,3.83,0,0,0-.42.28.91.91,0,0,1-.38.19.79.79,0,0,1-.72-.22,1,1,0,0,0-1.1-.19.91.91,0,0,0-.41.36,3,3,0,0,0-.28.41C390.22,262.24,390.35,262.14,390.49,262.05Zm-20.13,5.55a.88.88,0,0,1,.38-.2.78.78,0,0,1,.72.19,1,1,0,0,0,1.52-.12c.09-.14.19-.27.27-.42-.14.08-.27.18-.41.27a.81.81,0,0,1-1.1,0,1,1,0,0,0-1.11-.2,1.21,1.21,0,0,0-.41.36c-.09.14-.19.27-.28.42A3.83,3.83,0,0,0,370.36,267.6Zm-20-4.79a1,1,0,0,1,.38-.21.78.78,0,0,1,.72.19,1,1,0,0,0,1.09.23,1.07,1.07,0,0,0,.43-.35c.09-.14.19-.27.27-.42a3.71,3.71,0,0,0-.41.28,1,1,0,0,1-.39.19.78.78,0,0,1-.71-.22,1,1,0,0,0-1.11-.19,1,1,0,0,0-.41.36l-.28.41C350.09,263,350.22,262.9,350.36,262.81Zm46,12.12a1,1,0,0,1,.38-.21.75.75,0,0,1,.71.19,1,1,0,0,0,1.1.23,1,1,0,0,0,.42-.35,3.83,3.83,0,0,0,.28-.42c-.15.08-.28.19-.42.28a.91.91,0,0,1-.38.19.77.77,0,0,1-.71-.22,1,1,0,0,0-1.11-.19.91.91,0,0,0-.41.36c-.1.14-.2.27-.28.41C396.05,275.12,396.18,275,396.32,274.93Zm2.93-19.79a.83.83,0,0,1,.38-.2.73.73,0,0,1,.71.18,1,1,0,0,0,1.1.23.91.91,0,0,0,.42-.35,3.83,3.83,0,0,0,.28-.42c-.15.09-.28.19-.42.28a.91.91,0,0,1-.38.19.74.74,0,0,1-.71-.22,1,1,0,0,0-1.11-.19.91.91,0,0,0-.41.36c-.09.14-.2.27-.28.42C399,255.33,399.11,255.23,399.25,255.14ZM346.2,269.85a.71.71,0,0,1-.2.12c0,.11,0,.21,0,.32a1.1,1.1,0,0,0,.34-.3c.08-.14.19-.27.27-.42C346.47,269.65,346.34,269.75,346.2,269.85Zm4.16-30.59a1.07,1.07,0,0,1,.38-.2.75.75,0,0,1,.71.19,1,1,0,0,0,1.1.23,1,1,0,0,0,.42-.35,3.83,3.83,0,0,0,.28-.42,3.83,3.83,0,0,0-.42.28.91.91,0,0,1-.38.19.77.77,0,0,1-.71-.22,1,1,0,0,0-1.11-.2,1,1,0,0,0-.41.36c-.09.14-.2.27-.28.42A3.83,3.83,0,0,0,350.36,239.26Z",
    fill: "#fff",
    style: {
      transformOrigin: "378.245px 241.69px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "361.08 218.21 358.53 213.52 354.62 217.8 355.74 221.35 359.48 221.64",
    fill: "#263238",
    style: {
      transformOrigin: "357.85px 217.58px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "359.48 221.64 363.36 263.27 359.05 276.69 352.98 263.07 355.74 221.35",
    fill: "#263238",
    style: {
      transformOrigin: "358.17px 249.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m358.86 212.61c3.53 0.46 8.9-5.42 10.8-9.93 0.12-0.31-0.64-3.35-1.4-7.08-0.45-2.27-0.9-4.81-1.15-7.15l-14.33 5.09a37.59 37.59 0 0 1 2.36 8.86 6.24 6.24 0 0 1 0 1v0.16c-0.14 1.83 0.31 8.6 3.72 9.05z",
    fill: "#eb9481",
    style: {
      transformOrigin: "361.226px 200.543px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M366.68,188.6c-.21,3-1.57,13.79-10,14.86a11.72,11.72,0,0,1-1.52.07v-.16a4.48,4.48,0,0,0,0-1,38.13,38.13,0,0,0-2.36-8.86Z",
    fill: "#263238",
    style: {
      transformOrigin: "359.74px 196.066px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m368 172.62c1.89 5.14 0 20.41-3.53 24-5.12 5.19-13.92 6.16-18.45-0.08-4.38-6.06-1.56-25.92 2.43-29.22 5.81-4.86 16.69-2.32 19.55 5.3z",
    fill: "#eb9481",
    style: {
      transformOrigin: "356.277px 182.855px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m352.74 182.58s0.07 0.06 0.06 0.1c-0.18 1-0.21 2.21 0.66 2.68v0c-1.12-0.27-1.06-1.85-0.72-2.78z",
    fill: "#263238",
    style: {
      transformOrigin: "352.992px 183.983px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m353.8 181.65c1.66 0.11 1.31 3.42-0.23 3.31s-1.16-3.41 0.23-3.31z",
    fill: "#263238",
    style: {
      transformOrigin: "353.735px 183.305px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m346.94 182.16s-0.09 0-0.09 0.08c-0.07 1-0.33 2.19-1.3 2.43a0 0 0 0 0 0 0.06c1.15-0.04 1.45-1.59 1.39-2.57z",
    fill: "#263238",
    style: {
      transformOrigin: "346.249px 183.445px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m346.14 181c-1.63-0.3-2.11 3-0.6 3.27s1.97-3.03 0.6-3.27z",
    fill: "#263238",
    style: {
      transformOrigin: "345.792px 182.633px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M355.26,180.28c-.43-.17-.81-.39-1.23-.59a2.2,2.2,0,0,1-1.14-.84.7.7,0,0,1,.2-.83,1.75,1.75,0,0,1,1.77,0,2.6,2.6,0,0,1,1.35,1.26A.76.76,0,0,1,355.26,180.28Z",
    fill: "#263238",
    style: {
      transformOrigin: "354.546px 179.05px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M345,179.19c.46,0,.89-.13,1.35-.2a2.2,2.2,0,0,0,1.33-.47.69.69,0,0,0,0-.86,1.74,1.74,0,0,0-1.69-.5,2.57,2.57,0,0,0-1.66.8A.75.75,0,0,0,345,179.19Z",
    fill: "#263238",
    style: {
      transformOrigin: "345.991px 178.153px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M353.08,192c-.23.26-.44.62-.81.68a2.72,2.72,0,0,1-1.13-.16,0,0,0,0,0,0,.06,1.4,1.4,0,0,0,1.36.44,1.1,1.1,0,0,0,.72-1C353.19,191.94,353.11,191.92,353.08,192Z",
    fill: "#263238",
    style: {
      transformOrigin: "352.18px 192.502px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M352.1,188.88a3.51,3.51,0,0,1-2.49,1.31,4.44,4.44,0,0,1-1.26-.08,3.84,3.84,0,0,1-.46-.11.25.25,0,0,1-.18-.25h0s.3-2.18.3-2.18c-.3.11-1.84.62-1.77.21a53,53,0,0,1,2.46-10.41c0-.1.21-.06.19,0-.42,3.28-1.4,6.46-1.87,9.74a6.56,6.56,0,0,1,1.7-.32c.06,0-.44,2.67-.43,2.69a4.86,4.86,0,0,0,3.72-.74C352.1,188.73,352.17,188.81,352.1,188.88Z",
    fill: "#263238",
    style: {
      transformOrigin: "349.183px 183.757px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M367.59,185.19c-3.82,0-4.63-6.9-4.63-6.9s-6.57-1-7.57-5.94c0,0-6.19,4-11.1,2.31s-4.3-7.81-3.75-9c1.24-2.71,5.35.72,5.35.72s6.13-3.8,13.14-3.17c5.7.5,8.61,5.84,8.61,5.84s3.07.62,4.08,2.75S370,185.17,367.59,185.19Z",
    fill: "#263238",
    style: {
      transformOrigin: "356.056px 174.165px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M364.5,178.32c-5.06.72-8.46-2.61-9.25-7.46,0-.06-.1-.06-.09,0,.19,4.53,4.47,9.53,9.39,7.68A.11.11,0,0,0,364.5,178.32Z",
    fill: "#263238",
    style: {
      transformOrigin: "359.899px 174.875px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M367.5,169a.05.05,0,0,0,0,.1c1.43.64,3.06,1.12,4.07,2.4,1.22,1.55,1,3.61.55,5.39-.67,2.76-2,6.35-4.5,8-.14.09,0,.3.15.21,2.94-1.77,4.61-6.42,5-9.67C373.14,171.75,370.86,169.71,367.5,169Z",
    fill: "#263238",
    style: {
      transformOrigin: "370.13px 177.061px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M349.83,173.73a7,7,0,0,1-7.74-.12c-2.7-2-2.19-5.37-1.08-8.17.05-.13-.13-.28-.22-.15-1.54,2.46-1.6,6.19.61,8.3s6.21,2.09,8.65.47A.2.2,0,0,0,349.83,173.73Z",
    fill: "#263238",
    style: {
      transformOrigin: "344.9px 170.234px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m353.64 188.63a4.76 4.76 0 0 1-3.64-5.63 4.75 4.75 0 1 1 4.86 5.72 5.19 5.19 0 0 1-1.22-0.09zm-3.06-5.49a4.11 4.11 0 1 0 4.86-3.19 3.91 3.91 0 0 0-1-0.08 4.11 4.11 0 0 0-3.86 3.27z",
    fill: "#455a64",
    style: {
      transformOrigin: "354.648px 183.975px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M343.64,187.87c-1.95-.14-3.38-2.38-3.19-5a5.67,5.67,0,0,1,1.25-3.24,3,3,0,0,1,5.05.37,5.67,5.67,0,0,1,.76,3.38c-.18,2.48-1.75,4.41-3.56,4.49Zm-1.46-7.82a5.05,5.05,0,0,0-1.09,2.88c-.17,2.26,1,4.19,2.59,4.31s3-1.63,3.2-3.89a5.07,5.07,0,0,0-.67-3,2.55,2.55,0,0,0-1.93-1.31H344A2.65,2.65,0,0,0,342.18,180.05Z",
    fill: "#455a64",
    style: {
      transformOrigin: "343.983px 183.145px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m350.07 183.57 0.45-0.45c-0.68-0.66-2.28-1.59-3.53-0.44l0.43 0.47c1.12-1.04 2.58 0.36 2.65 0.42z",
    fill: "#455a64",
    style: {
      transformOrigin: "348.755px 182.853px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M371.09,186.33l.59-.25c-.12-.27-1.18-2.67-2.58-3s-9.85-.13-10.22-.12l0,.63c2.45-.05,9-.14,10.05.1S370.81,185.67,371.09,186.33Z",
    fill: "#455a64",
    style: {
      transformOrigin: "365.28px 184.61px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m364.45 185.66s3.24-5 5.51-3.88 0 8.32-2.62 9.39a2.64 2.64 0 0 1-3.6-1.29z",
    fill: "#eb9481",
    style: {
      transformOrigin: "367.316px 186.534px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M369.24,183.82c.05,0,.06.06,0,.07-1.8.81-2.7,2.54-3.31,4.32a1.48,1.48,0,0,1,2.18-.48c.05,0,0,.11-.05.1a1.63,1.63,0,0,0-1.77.64,7.84,7.84,0,0,0-.81,1.48c-.08.17-.38.09-.32-.1v0C365.06,187.48,366.75,184.15,369.24,183.82Z",
    fill: "#263238",
    style: {
      transformOrigin: "367.217px 186.932px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m355.15 203 3.73 8.48 10.33-11.21 3.14 3.39s-9.9 17.61-10 16.83l-3.78-7.3-4.95 5.32v-13z",
    fill: "#0057ff",
    style: {
      transformOrigin: "362.985px 210.393px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M353.27,212.15c.08-2.14.09-4.3.26-6.43,0-.07.12-.11.14,0,.5,2,.18,10.22.25,12.18l0,0c.21-.23,4.6-4.68,4.64-4.62.81,1.16,3.58,6.47,3.77,7,1.57-2.79,8.24-13.83,10.11-16.49a.07.07,0,0,1,.13.07c-1.37,2.94-10,17.51-10.1,17.47a83.53,83.53,0,0,1-4-7.71c-.73,1-5.15,6-5.17,5.66A66,66,0,0,1,353.27,212.15Z",
    fill: "#263238",
    style: {
      transformOrigin: "362.883px 212.541px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 311.73,
    y: 231.68,
    width: 40.69,
    height: 52.97,
    fill: "#c7c7c7",
    style: {
      transformOrigin: "332.075px 258.165px",
      transform: "rotate(-2.34deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 321.53,
    y: 228.98,
    width: 19.29,
    height: 5.84,
    fill: "#263238",
    style: {
      transformOrigin: "331.175px 231.9px",
      transform: "rotate(-2.28deg)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "336.32 228.78 333.95 228.87 333.84 226.18 328.07 226.41 328.18 229.1 325.81 229.19 325.61 224.29 336.16 223.87",
    fill: "#263238",
    style: {
      transformOrigin: "330.965px 226.53px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m381.51 216.42c12.07 21.58 17.49 52.73 12.26 60.47-3.75 5.6-36.34 5.45-55.31 4.84-3.5-0.11 1-28.73 4.77-28.37 6.67 0.64 28.66-0.94 29.12-0.93 1 0-1.57-19.83-2.21-32.72-0.83-16.43 5.96-12.93 11.37-3.29z",
    fill: "#eb9481",
    style: {
      transformOrigin: "366.479px 245.154px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m308 252.78a4.33 4.33 0 0 0 1.13 4.83 6.45 6.45 0 0 0-2.57 3.57c-0.61 2.58 3.19 4.67 3.19 4.67a8 8 0 0 0-2.12 4.19c-0.33 2.54 3.2 5.19 3.2 5.19a7 7 0 0 0 0.46 4.86c2.12 4 8.95 4.41 13.29 4.74s17-2.78 19.43-3.13l2.4-27.84s-19-7-24.2-6.71c-4.4 0.28-12.89 2.52-14.21 5.63z",
    fill: "#eb9481",
    style: {
      transformOrigin: "326.452px 265.998px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M309.13,257.5c4.55-1.4,9.27-1.38,14-1.63.1,0,.11.16,0,.16-4.69.19-9.28,1.32-13.95,1.7A.12.12,0,0,1,309.13,257.5Z",
    fill: "#263238",
    style: {
      transformOrigin: "316.133px 256.8px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M309.68,265.75a12.55,12.55,0,0,1,3.24-.24c1.15,0,2.3,0,3.45.05,2.3.07,4.6.19,6.89.38.11,0,.12.16,0,.16-2.29-.06-4.59-.09-6.88-.06-1.15,0-2.3,0-3.45.08a14.71,14.71,0,0,1-3.25-.06A.16.16,0,0,1,309.68,265.75Z",
    fill: "#263238",
    style: {
      transformOrigin: "316.453px 265.836px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m310.87 275.23a8.73 8.73 0 0 1 2.93-0.05l3.15 0.14c2.09 0.08 4.19 0.17 6.29 0.17 0.1 0 0.11 0.17 0 0.17h-6.4-3.14a8.19 8.19 0 0 1-2.84-0.29 0.06 0.06 0 0 1 0.01-0.14z",
    fill: "#263238",
    style: {
      transformOrigin: "317.057px 275.381px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M346,252.87l.45,29.92s41.55.82,47.36-4.45,1.23-36.9-10-59c-6.15-12.09-14.89-19.43-14.14,2.26s2.18,29.67,2.07,29.9S346,252.87,346,252.87Z",
    fill: "#0057ff",
    style: {
      transformOrigin: "371.168px 245.284px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M372.84,232.12l-.48.09a.91.91,0,0,1-.56-.05,1,1,0,0,1-.6-.93.77.77,0,0,0-.38-.64.87.87,0,0,0-.42-.13l-.36-.07v-.06l.36-.07a1,1,0,0,1,1.2,1,.81.81,0,0,0,.34.66,1,1,0,0,0,.42.14A4.1,4.1,0,0,1,372.84,232.12Zm6.63,30.76a.86.86,0,0,1,.41.13.76.76,0,0,1,.38.64,1,1,0,0,0,.61.93,1,1,0,0,0,.55.05,4.74,4.74,0,0,0,.49-.1l-.49-.1a.86.86,0,0,1-.41-.13.79.79,0,0,1-.35-.66,1,1,0,0,0-.65-.92,1,1,0,0,0-.54,0l-.49.1A4.26,4.26,0,0,0,379.47,262.88Zm.19-47.53a1,1,0,0,1,.42.13.76.76,0,0,1,.37.64,1,1,0,0,0,.61.93,1,1,0,0,0,.55.06l.49-.1a4.26,4.26,0,0,0-.49-.1.87.87,0,0,1-.41-.14.79.79,0,0,1-.35-.66,1,1,0,0,0-.64-.92,1,1,0,0,0-.55,0,4.26,4.26,0,0,0-.49.1C379.33,215.3,379.5,215.32,379.66,215.35Zm-31.8,64.33a.87.87,0,0,1-.41-.14.76.76,0,0,1-.34-.66,1,1,0,0,0-.65-.91l-.1,0v.35a.74.74,0,0,1,.33.6,1,1,0,0,0,1.16,1,4.91,4.91,0,0,0,.5-.1Zm29.84-6.12a.86.86,0,0,1,.41.13.76.76,0,0,1,.38.64,1,1,0,0,0,.61.93,1,1,0,0,0,.55.05l.49-.09a4.74,4.74,0,0,0-.49-.1,1,1,0,0,1-.41-.14.79.79,0,0,1-.35-.66,1,1,0,0,0-.65-.92,1,1,0,0,0-.54,0l-.49.1A4.26,4.26,0,0,0,377.7,273.56Zm-25.45-3.37a.86.86,0,0,1,.41.13.73.73,0,0,1,.37.64,1,1,0,0,0,.62.93,1,1,0,0,0,.55.05,4.74,4.74,0,0,0,.49-.1l-.49-.09a1,1,0,0,1-.41-.14.74.74,0,0,1-.35-.66,1,1,0,0,0-.65-.92,1,1,0,0,0-.54,0l-.49.1A3.86,3.86,0,0,0,352.25,270.19Zm15.13-12.42a1,1,0,0,1,.41.12.77.77,0,0,1,.38.64,1,1,0,0,0,.61.94,1,1,0,0,0,.55,0,4.74,4.74,0,0,0,.49-.1l-.49-.1a1,1,0,0,1-.41-.13.79.79,0,0,1-.35-.66,1,1,0,0,0-.65-.92.92.92,0,0,0-.54,0,4.26,4.26,0,0,0-.49.1A4.26,4.26,0,0,0,367.38,257.77Zm-21.33-1.54v.15l.37-.08Zm40.52,21.9a1,1,0,0,1,.41.12.77.77,0,0,1,.38.64,1,1,0,0,0,.61.94,1,1,0,0,0,.55.05,4.26,4.26,0,0,0,.49-.1l-.49-.1a1,1,0,0,1-.41-.13.82.82,0,0,1-.35-.66,1,1,0,0,0-.64-.92,1,1,0,0,0-.55,0,4.26,4.26,0,0,0-.49.1ZM375.5,244.42a1,1,0,0,1,.41.12.74.74,0,0,1,.37.64,1,1,0,0,0,.62.94.92.92,0,0,0,.54,0,4.42,4.42,0,0,0,.5-.1,4.42,4.42,0,0,0-.5-.1.87.87,0,0,1-.4-.14.74.74,0,0,1-.35-.66,1,1,0,0,0-.65-.91.92.92,0,0,0-.54,0,4.42,4.42,0,0,0-.5.1Zm13.59,8.51a.87.87,0,0,1,.42.13.75.75,0,0,1,.37.63,1,1,0,0,0,.62.94.92.92,0,0,0,.54.05,3.86,3.86,0,0,0,.49-.1l-.49-.1a.94.94,0,0,1-.4-.13.76.76,0,0,1-.35-.66,1,1,0,0,0-.65-.92,1,1,0,0,0-.55,0l-.49.1A4.74,4.74,0,0,0,389.09,252.93Zm-.07-8.75a.94.94,0,0,1-.38.2.73.73,0,0,1-.72-.19,1,1,0,0,0-1.09-.22.94.94,0,0,0-.43.35l-.28.41c.15-.08.28-.18.42-.27a.85.85,0,0,1,.38-.19.77.77,0,0,1,.72.22,1,1,0,0,0,1.11.19,1,1,0,0,0,.41-.36c.09-.14.19-.27.28-.42C389.29,244,389.16,244.09,389,244.18Zm-16.53-35.5a1.12,1.12,0,0,1-.38.21.79.79,0,0,1-.55-.07,1.81,1.81,0,0,0-.22.32.94.94,0,0,0,.88,0,1,1,0,0,0,.41-.36c.08-.14.18-.27.27-.41A3.62,3.62,0,0,0,372.49,208.68Zm-.33,10.52a1,1,0,0,1-.13.41.75.75,0,0,1-.64.37,1,1,0,0,0-.93.62.93.93,0,0,0-.06.54c0,.17.06.33.1.49a3.86,3.86,0,0,0,.1-.49.87.87,0,0,1,.14-.4.74.74,0,0,1,.66-.35,1,1,0,0,0,1-1.19c0-.17-.05-.33-.09-.5A4.42,4.42,0,0,0,372.16,219.2Zm16.4,50.24a1,1,0,0,1-.13.41.76.76,0,0,1-.64.38,1,1,0,0,0-.93.61,1,1,0,0,0-.06.55c0,.16.06.33.1.49a4.26,4.26,0,0,0,.1-.49.87.87,0,0,1,.14-.41.79.79,0,0,1,.66-.35,1,1,0,0,0,.95-1.19c0-.16-.05-.33-.09-.49A4.26,4.26,0,0,0,388.56,269.44Zm-5.68-33.59a1,1,0,0,1-.13.42.75.75,0,0,1-.64.37,1,1,0,0,0-.93.61,1,1,0,0,0-.05.55c0,.16.05.33.09.49a4.26,4.26,0,0,0,.1-.49.9.9,0,0,1,.14-.4.77.77,0,0,1,.66-.36,1,1,0,0,0,.92-.64,1.05,1.05,0,0,0,0-.55c0-.16-.06-.33-.1-.49A4.26,4.26,0,0,0,382.88,235.85Zm-21,29.17a.87.87,0,0,1-.13.42.75.75,0,0,1-.64.37,1,1,0,0,0-.93.62.92.92,0,0,0-.05.54,3.86,3.86,0,0,0,.1.49c0-.16.06-.32.1-.49a.86.86,0,0,1,.13-.4.74.74,0,0,1,.66-.35,1,1,0,0,0,.92-.65,1,1,0,0,0,0-.55c0-.16-.06-.32-.1-.49A4.74,4.74,0,0,0,361.87,265ZM356,277.56a1,1,0,0,1-.13.41.77.77,0,0,1-.64.38,1,1,0,0,0-.93.61,1,1,0,0,0-.06.55c0,.16.06.32.1.49a4.74,4.74,0,0,0,.1-.49.87.87,0,0,1,.14-.41.79.79,0,0,1,.66-.35,1,1,0,0,0,.95-1.19,4.26,4.26,0,0,0-.1-.49C356,277.23,356,277.4,356,277.56Zm15.18-.63a1,1,0,0,1-.12.42.76.76,0,0,1-.64.37,1,1,0,0,0-.94.62.92.92,0,0,0,0,.54,3.86,3.86,0,0,0,.1.49,3.86,3.86,0,0,0,.1-.49.83.83,0,0,1,.14-.4.74.74,0,0,1,.66-.35,1,1,0,0,0,.91-.65,1,1,0,0,0,0-.55,4.74,4.74,0,0,0-.1-.49C371.22,276.61,371.2,276.77,371.16,276.93Zm8.34-50.09a1,1,0,0,1,.38-.21.78.78,0,0,1,.72.19,1,1,0,0,0,1.09.23,1.07,1.07,0,0,0,.43-.35c.09-.14.19-.27.27-.42a4.21,4.21,0,0,0-.41.28,1,1,0,0,1-.39.19.78.78,0,0,1-.71-.22,1,1,0,0,0-1.11-.19,1,1,0,0,0-.41.36l-.28.41C379.23,227,379.36,226.93,379.5,226.84Zm-22.24,29.7a.83.83,0,0,1,.38-.2.73.73,0,0,1,.71.19,1,1,0,0,0,1.1.22.91.91,0,0,0,.42-.35c.09-.14.2-.27.28-.41-.15.08-.28.18-.42.27a.8.8,0,0,1-.38.19.77.77,0,0,1-.72-.22,1,1,0,0,0-1.1-.19.91.91,0,0,0-.41.36,3.83,3.83,0,0,0-.28.42C357,256.74,357.12,256.63,357.26,256.54Zm3.88,18.39a1,1,0,0,1,.38-.21.78.78,0,0,1,.72.19,1,1,0,0,0,1.09.23,1.07,1.07,0,0,0,.43-.35c.09-.14.19-.27.27-.42a4.21,4.21,0,0,0-.41.28,1,1,0,0,1-.39.19.78.78,0,0,1-.71-.22,1,1,0,0,0-1.11-.19,1,1,0,0,0-.41.36l-.28.41C360.87,275.12,361,275,361.14,274.93Zm17.38-20.21a.94.94,0,0,1,.38-.2.75.75,0,0,1,.72.19,1,1,0,0,0,1.09.22.88.88,0,0,0,.43-.35l.28-.41c-.15.08-.28.18-.42.27a.83.83,0,0,1-.39.19.75.75,0,0,1-.71-.21,1,1,0,0,0-1.11-.2,1.11,1.11,0,0,0-.41.36c-.09.14-.19.27-.28.42C378.25,254.92,378.38,254.81,378.52,254.72Zm12,7.33a1,1,0,0,1,.38-.21.75.75,0,0,1,.71.19,1,1,0,0,0,1.1.23,1,1,0,0,0,.42-.35c.09-.14.2-.27.28-.42a3.83,3.83,0,0,0-.42.28.91.91,0,0,1-.38.19.79.79,0,0,1-.72-.22,1,1,0,0,0-1.1-.19.91.91,0,0,0-.41.36,3,3,0,0,0-.28.41C390.22,262.24,390.35,262.14,390.49,262.05Zm-20.13,5.55a.88.88,0,0,1,.38-.2.78.78,0,0,1,.72.19,1,1,0,0,0,1.52-.12c.09-.14.19-.27.27-.42-.14.08-.27.18-.41.27a.81.81,0,0,1-1.1,0,1,1,0,0,0-1.11-.2,1.21,1.21,0,0,0-.41.36c-.09.14-.19.27-.28.42A3.83,3.83,0,0,0,370.36,267.6Zm-20-4.79a1,1,0,0,1,.38-.21.78.78,0,0,1,.72.19,1,1,0,0,0,1.09.23,1.07,1.07,0,0,0,.43-.35c.09-.14.19-.27.27-.42a3.71,3.71,0,0,0-.41.28,1,1,0,0,1-.39.19.78.78,0,0,1-.71-.22,1,1,0,0,0-1.11-.19,1,1,0,0,0-.41.36l-.28.41C350.09,263,350.22,262.9,350.36,262.81Zm-4.12,7v.27l.09-.1c.08-.14.19-.27.27-.42A4,4,0,0,0,346.24,269.82Z",
    fill: "#fff",
    style: {
      transformOrigin: "369.74px 244.185px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "343.37 284.04 350.63 283.71 349.44 251.03 342.46 250.86",
    fill: "#0057ff",
    style: {
      transformOrigin: "346.545px 267.45px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M350.38,267.37q-.19-3.39-.43-6.78c-.15-2.24-.23-4.53-.53-6.76,0-.1-.17-.11-.17,0-.08,2.18.07,4.39.14,6.57s.17,4.62.27,6.93c.19,4.57.55,9.12,1,13.67,0,.11.15.08.15,0C350.75,276.43,350.65,271.9,350.38,267.37Z",
    fill: "#263238",
    style: {
      transformOrigin: "350.019px 267.411px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M396,257.13a110.28,110.28,0,0,0-5.18-21.35l-.12-.34c-.14-.87-.28-1.75-.43-2.62-.26-1.4-.6-2.78-1-4.16,0-.06-.1,0-.1,0,.19,1.4.37,2.8.65,4.18.05.2.09.4.14.6-1.13-3.15-2.36-6.28-3.72-9.34,0-.06-.12,0-.1,0,2.42,6.82,4.74,13.64,6.48,20.68a106.4,106.4,0,0,1,3,21.16c.08,2,.11,4,0,5.94a12.27,12.27,0,0,1-1.2,5.64c-.05.1.1.18.15.09a13.5,13.5,0,0,0,1.59-4.51,35.49,35.49,0,0,0,.38-5.15A73,73,0,0,0,396,257.13Z",
    fill: "#263238",
    style: {
      transformOrigin: "391.35px 250.861px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M373.94,251.54c-.66-.08-1.32-.13-2-.17a94.88,94.88,0,0,0-.69-11.17c-.4-3.81-.82-7.62-1.31-11.42a0,0,0,0,0-.07,0c.09,2.41.22,4.82.36,7.23-.25-1.17-.47-2.35-.68-3.52,0-.08-.14-.06-.14,0a22.44,22.44,0,0,0,.52,3.25c.11.45.24.89.37,1.34.06,1.08.13,2.16.2,3.25a92.45,92.45,0,0,0,1.19,11,93.36,93.36,0,0,0-10,.21,111.82,111.82,0,0,0-12.12,1.1,6.3,6.3,0,0,0,.08-2c-.2-.27-5.82-.23-7.57-.06a20.35,20.35,0,0,0,.32,2.43.09.09,0,0,0,.17,0c0-.74-.06-1.15-.08-2,1.13,0,6.41,0,6.67,0a10.48,10.48,0,0,0,.23,1.82s8.26-.41,12.32-.59c2-.1,4-.16,6-.22s4.12,0,6.17-.27C374.07,251.85,374.14,251.56,373.94,251.54Z",
    fill: "#263238",
    style: {
      transformOrigin: "358.07px 240.925px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "184.183px 153.612px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M203.77,155.56A17.82,17.82,0,0,1,174,166.83l-8.91,1.31,4.46-7.71a17.64,17.64,0,0,1-1.23-8.58,17.83,17.83,0,0,1,35.46,3.71Z",
    fill: "#fff",
    style: {
      transformOrigin: "184.467px 153.866px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M203.77,155.56a18.06,18.06,0,0,1-3.6,9,16.2,16.2,0,0,1-3.5,3.45,17.28,17.28,0,0,1-4.3,2.4,17.53,17.53,0,0,1-4.79,1.14,17.12,17.12,0,0,1-2.48,0,15.8,15.8,0,0,1-2.47-.26,17.89,17.89,0,0,1-8.81-4.35l.21.06-8.91,1.37-.64.1.32-.57,4.44-7.72,0,.3a18,18,0,1,1,34.55-5Zm0,0a17.65,17.65,0,0,0-20.21-19.29,17.6,17.6,0,0,0-7.36,2.91,18.35,18.35,0,0,0-5.34,5.82,17.54,17.54,0,0,0-2.26,7.54,17.89,17.89,0,0,0,1.26,7.76l.06.16-.08.14-4.49,7.7-.32-.47,8.92-1.25.13,0,.08.08a17.57,17.57,0,0,0,8.54,4.4,15,15,0,0,0,2.42.29,16.43,16.43,0,0,0,2.43,0,17.64,17.64,0,0,0,4.76-1.05,16.41,16.41,0,0,0,4.3-2.32,18.84,18.84,0,0,0,1.88-1.57,20.23,20.23,0,0,0,1.63-1.84A18,18,0,0,0,203.77,155.56Z",
    fill: "#263238",
    style: {
      transformOrigin: "184.183px 153.612px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m186.44 142.1a1.14 1.14 0 0 1 1.15 1.15v0.59a9.85 9.85 0 0 1 4.16 1.47 1.45 1.45 0 0 1 0.8 1.29 1.47 1.47 0 0 1-1.5 1.47 1.46 1.46 0 0 1-0.8-0.24 10 10 0 0 0-2.76-1.18v5.15c4.07 1 5.81 2.65 5.81 5.52s-2.3 4.91-5.71 5.23v1.61a1.14 1.14 0 0 1-1.15 1.15 1.17 1.17 0 0 1-1.18-1.15v-1.66a11.64 11.64 0 0 1-5.49-2.09 1.49 1.49 0 0 1-0.73-1.29 1.46 1.46 0 0 1 1.48-1.48 1.44 1.44 0 0 1 0.88 0.3 9.53 9.53 0 0 0 4 1.8v-5.29c-3.91-1-5.74-2.49-5.74-5.52 0-2.87 2.28-4.85 5.63-5.12v-0.56a1.17 1.17 0 0 1 1.15-1.15zm-1.07 9.14v-4.75c-1.72 0.16-2.57 1.08-2.57 2.25s0.51 1.83 2.57 2.5zm2.12 3.72v4.88c1.71-0.19 2.65-1 2.65-2.33s-0.59-1.9-2.65-2.51z",
    fill: "#0057ff",
    style: {
      transformOrigin: "186.17px 153.705px"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotransactions);
export default __webpack_public_path__ + "static/media/notransactions.822590c4dff5994740053684b1cd6b2e.svg";
export { ForwardRef as ReactComponent };